import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { Fir5471ScheduleOService } from './fir-5471-schedule-o.service';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import * as _ from 'lodash-es';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';
import { parseAsLocalDate } from '../../../shared/_utils';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-fir-5471-schedule-o',
    templateUrl: './fir-5471-schedule-o.component.html',
    styleUrls: ['./fir-5471-schedule-o.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Fir5471ScheduleOComponent implements OnInit, OnDestroy {
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private unsubscribe$ = new Subject<void>();
  private subscriptions = new Subscription();

  // STANDARD COMPONENT PROPERTIES
  currentTabName = "Form Entry";
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  isInitialized = false;

  // Entity data properties
  entityList: any[] = [];
  modalTitle = "Schedule O";

  // Base inputs
  baseURLs: GtwElementsBaseUrlsModel = {'admin':'','api':'','custom':'','efile':'','pdfEngine':'','bulkPdfEngine':''};
  globalService: any;
  GENERAL_CONFIG: any;
  rowData: any = {};
  filterParams: any = {};

  // Component-specific properties
  showFormLoader = false;
  showF5471ScheduleO: boolean | null = null;
  body = "";
  pendingApiCalls = 0;
  isDataFullyLoaded = false;
  activeTab = 0;
  
  // Validation properties
  submitted = false;
  validationErrors: {[key: string]: string} = {};
  
  // Validation flags for date validation
  tab5471_date_flag = false;
  C_date_flag = false;
  D_date_flag = false;
  E_date_flag = false;
  A_date_flag = false;
  
  // Section-specific validation flags  
  tabA_flag = false;
  tabB_flag = false;
  tabC_flag = false;
  tabD_flag = false;
  tabE_flag = false;
  
  // Tab data
  tabs = [
    { id: 0, name: '5471' },
    { id: 5, name: 'Add new Section A' },
    { id: 4, name: 'Add new Section B' },
    { id: 1, name: 'Add new Stock Acquisition' },
    { id: 2, name: 'Add new Stock Disposition' },
    { id: 3, name: 'Add new Reorganization Information' }
  ];

  // Section data
  selectedTabAData: any[] = [];
  selectedTabBData: any[] = [];
  selectedTabCData: any[] = [];
  selectedTabDData: any[] = [];
  selectedTabEData: any[] = [];
  selectedTab5471Data: any[] = [];

  // Store original API metadata for dynamic lookups (matching AngularJS vm.tabXAttribDetails)
  tabBAttribDetails: any[] = [];
  tabCAttribDetails: any[] = [];
  tabDAttribDetails: any[] = [];
  tabEAttribDetails: any[] = [];
  
  // Main tab data and display data
  tab5471Data: any[] = [];
  sectionAData: any[] = [];
  sectionBData: any[] = [];
  sectionCData: any[] = [];
  sectionDData: any[] = [];
  sectionEData: any[] = [];
  
  // Original data for reset functionality
  tab5471OriginalData: any[] = [];
  selectedTabAOriginalData: any[] = [];
  selectedTabBOriginalData: any[] = [];
  selectedTabCOriginalData: any[] = [];
  selectedTabDOriginalData: any[] = [];
  selectedTabEOriginalData: any[] = [];
  
  // Temporary storage for user input before API loads
  tempUserInput: {[key: number]: any} = {};
  
  // Edit flags and validation flags
  editFlag = false;
  tabAFlag = false;
  tabBFlag = false;
  
  // Track which item is currently being deleted for spinner display
  deletingItem: any = null;
  tabCFlag = false;
  tabDFlag = false;
  tabEFlag = false;
  
  // Data from API calls
  countries: any[] = [];
  corpNameChangeData: any = {};
  scheduleODetailsTemp: any[] = [];
  filingGroup: any[] = [];
  tempOldscheduleData: any[] = [];
  states: any[] = [];
  
  // Collapse states for sections
  collapsed1 = true; // Section C
  collapsed2 = true; // Section D
  collapsed3 = true; // Section E
  collapsed4 = true; // Section B
  collapsed5 = true; // Section A

  constructor(
    private gtwSnackbarService: GtwSnackbarService,
    private fir5471ScheduleOService: Fir5471ScheduleOService,
    private jsonObjectFactory: JsonObjectFactoryService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const shell = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    const hydrated = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    let fp = normalizeFilterParams(activeScreen);
    if (!Object.keys(fp).length) {
      fp = extractObject(hydrated);
    }
    this.filterParams = fp;
    const mergedGp = { ...extractObject(shell.globalParams), ...extractObject(hydrated) };
    this.globalService = {
      ...shell,
      globalParams: mergedGp,
      filterParams: fp,
      workspaceFactory: this.gtwWorkspace.workspaceFactory,
      getScenario: (ty: any) => this.gtwGlobal.getScenario(ty),
      getEIN: () => this.gtwGlobal.getEIN(),
      getTAXYEAR: () => this.gtwGlobal.getTAXYEAR(),
      getChartType: () => this.gtwGlobal.getChartType(),
      inputs: this.gtwGlobal.inputs,
      sso_id: this.gtwApp?.USER_SETTINGS?.user?.sso_id ?? ''
    };
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = { ...gc, base_url: gc.base_url || gc.api || '' };
    this.baseURLs = gc;
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    const rowObj = Array.isArray(rawRow)
      ? extractObject(rawRow[0]?.data ?? rawRow[0])
      : extractObject(rawRow);
    this.rowData = rowObj;
  }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.resetAndInit();
    this.subscriptions.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.resetAndInit();
      })
    );
    this.subscriptions.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.resetAndInit();
      })
    );
  }

  private resetAndInit(): void {
    this.isInitialized = false;
    this.init();
  }

  // API call tracking methods for comprehensive loading state
  private startApiCall() {
    this.pendingApiCalls++;
    this.showFormLoader = true;
    this.isDataFullyLoaded = false;
  }

  private finishApiCall() {
    this.pendingApiCalls--;
    if (this.pendingApiCalls <= 0) {
      this.pendingApiCalls = 0;
      this.showFormLoader = false;
      this.isDataFullyLoaded = true;
    }
  }

  init() {
    try {
      // Prevent multiple initializations
      if (this.isInitialized) {
        return;
      }

      const baseOk = !!(this.baseURLs?.api || this.GENERAL_CONFIG?.base_url);
      if (
        !baseOk ||
        !this.globalService?.globalParams ||
        !this.rowData ||
        Object.keys(this.rowData).length === 0
      ) {
        return;
      }

      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.setupEntityData();
        this.checkForEnabled();
        this.isInitialized = true;
      }
    } catch (e) {
      console.error('Error in FIR 5471 Schedule O init:', e);
    }
  }

  private setupEntityData() {
    this.entityList = [
      {key: "Tax Year", value: this.rowData.TAX_YEAR},
      {key: "LEID", value: this.rowData.LEID},
      {key: "LE Name", value: this.rowData.LE_NAME}
    ];
  }

  checkForEnabled() {
    this.startApiCall();
    
    if (this.rowData.SCHD_O_ENABLED === undefined || this.rowData.SCHD_O_ENABLED === null) {
      let filterParams = this.filterParams;
      let params = _.merge({}, this.globalService.globalParams, filterParams);
      params.combination_key = this.rowData.HO_COMBINATION_KEY;

      this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + "/loadJsonObject?action_code=y5oe8m", params, this.globalService).pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any) => {
          try {
            if (data.callSuccess === "1") {
              if (data.jsonObject.length > 0 && data.jsonObject[0].SCHD_O_ENABLED == 'Y') {
                this.showF5471ScheduleO = true;
                this.loadInitialData();
              } else {
                this.body = "Schedule O is not enabled for this entity.";
                this.showF5471ScheduleO = false;
                this.finishApiCall();
              }
            } else if (data.errorMessage === "no access") {
              this.body = "Sorry you do not have access to do the requested action.";
              this.showF5471ScheduleO = false;
              this.finishApiCall();
            } else if (data.callSuccess === "0") {
              this.body = data.errorMessage || "Failed to check Schedule O availability. Please contact system administrator.";
              this.showF5471ScheduleO = false;
              this.finishApiCall();
            } else {
              this.body = "Schedule O is not enabled for this entity.";
              this.showF5471ScheduleO = false;
              this.finishApiCall();
            }
          } catch (error) {
            console.error('Error in checkForEnabled:', error);
            this.body = "Error checking Schedule O availability.";
            this.showF5471ScheduleO = false;
            this.finishApiCall();
          }
        }, (error) => {
          console.error('API error in checkForEnabled:', error);
          this.body = "Error checking Schedule O availability.";
          this.showF5471ScheduleO = false;
          this.finishApiCall();
        });
    } else {
      if (!this.rowData.SCHD_O_ENABLED) {
        this.body = "Schedule O is not enabled for this entity.";
        this.showF5471ScheduleO = false;
        this.finishApiCall();
      } else {
        this.showF5471ScheduleO = true;
        this.loadInitialData();
      }
    }
  }

  loadInitialData() {
    this.loadScheduleODetails();
  }

  loadScheduleODetails(isRefreshAfterSave: boolean = false) {
    this.startApiCall();
    
    let filterParams = this.filterParams;
    let params = _.merge({}, this.globalService.globalParams, filterParams);
    params.action_code = "lio6vp";
    params.combination_key = this.rowData.HO_COMBINATION_KEY;
    params.group_obj_key = this.rowData.GROUP_OBJ_KEY;
    params.irs_form_no = 'F5471';
    
    if (isRefreshAfterSave) {
      params._refresh = Date.now();
      params._nocache = 'true';
      params._timestamp = new Date().toISOString();
    }

    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + "/loadJsonObject", params, this.globalService).pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        try {
          if (data.callSuccess === "1") {
            this.sectionAData = [];
            this.sectionBData = [];
            this.sectionCData = [];
            this.sectionDData = [];
            this.sectionEData = [];
            this.tab5471Data = [];
            
            if (data.jsonObject && data.jsonObject.length > 0) {
              this.processScheduleOData(data.jsonObject);
            }
            
            this.processTab5471Data();
            
            if (isRefreshAfterSave) {
              this.activeTab = 0;
            }
            
            this.loadTabAttributeDetails();
          } else {
            this.body = data.errorMessage || "Failed to load Schedule O data.";
            this.showF5471ScheduleO = false;
            this.finishApiCall();
          }
        } catch (error) {
          console.error('Error loading Schedule O details:', error);
          this.body = "Error loading Schedule O data.";
          this.showF5471ScheduleO = false;
          this.finishApiCall();
        }
      }, (error) => {
        console.error('API error loading Schedule O details:', error);
        this.body = "Error loading Schedule O data.";
        this.showF5471ScheduleO = false;
        this.finishApiCall();
      });
  }

  loadTabAttributeDetails() {
    this.startApiCall();
    
    let params = {
      action_code: "iqrhud",
      tax_year: this.filterParams?.tax_year || this.globalService?.globalParams?.tax_year,
      combination_key: this.rowData.HO_COMBINATION_KEY,
      group_obj_key: this.rowData.GROUP_OBJ_KEY,
      scenario: this.filterParams?.scenario || this.globalService?.globalParams?.scenario,
      irs_form_no: 'F5471'
    };

    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + "/loadJsonObject", params, this.globalService).pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        try {
          
          if (data.callSuccess === "1") {
            this.processTabAttributeDetails(data.jsonObject);
            
            this.initializeAllSectionsAfterApiLoad();
            
            this.loadCountriesData();
          } else {
            this.body = data.errorMessage || "Failed to load tab attributes.";
            this.showF5471ScheduleO = false;
            this.finishApiCall();
          }
        } catch (error) {
          console.error('Error loading tab attributes:', error);
          this.body = "Error loading tab attributes.";
          this.showF5471ScheduleO = false;
          this.finishApiCall();
        }
      }, (error) => {
        console.error('API error loading tab attributes:', error);
        this.body = "Error loading tab attributes.";
        this.showF5471ScheduleO = false;
        this.finishApiCall();
      });
  }

  loadCountriesData() {
    this.startApiCall();
    
    let params = _.merge({}, this.globalService.globalParams, this.filterParams);
    params.action_code = "kbuwei";

    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + "/loadJsonObject", params, this.globalService).pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        try {
          if (data.callSuccess === "1") {
            this.countries = data.jsonObject;
            
            this.loadFilingGroupData();
          } else {
            this.body = data.errorMessage || "Failed to load countries data.";
            this.showF5471ScheduleO = false;
            this.finishApiCall();
          }
        } catch (error) {
          console.error('Error loading countries:', error);
          this.body = "Error loading countries data.";
          this.showF5471ScheduleO = false;
          this.finishApiCall();
        }
      }, (error) => {
        console.error('API error loading countries:', error);
        this.body = "Error loading countries data.";
        this.showF5471ScheduleO = false;
        this.finishApiCall();
      });
  }

  loadFilingGroupData() {
    this.startApiCall();
    
    let params = _.merge({}, this.globalService.globalParams, this.filterParams);
    params.action_code = "v63gc1";

    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + "/loadJsonObject", params, this.globalService).pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        try {
          if (data.callSuccess === "1") {
            this.filingGroup = data.jsonObject;
            
            this.loadCorpNameChangeData();
          } else {
            this.body = data.errorMessage || "Failed to load filing group data.";
            this.showF5471ScheduleO = false;
            this.finishApiCall();
          }
        } catch (error) {
          console.error('Error loading filing group:', error);
          this.body = "Error loading filing group data.";
          this.showF5471ScheduleO = false;
          this.finishApiCall();
        }
      }, (error) => {
        console.error('API error loading filing group:', error);
        this.body = "Error loading filing group data.";
        this.showF5471ScheduleO = false;
        this.finishApiCall();
      });
  }

  loadCorpNameChangeData() {
    this.startApiCall();
    
    let params = {
      action_code: "6pisbi",
      combination_key: this.rowData.HO_COMBINATION_KEY,
      group_obj_key: this.rowData.GROUP_OBJ_KEY,
      tax_year: this.filterParams?.tax_year || this.globalService?.globalParams?.tax_year,
      scenario: this.filterParams?.scenario || this.globalService?.globalParams?.scenario
    };

    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + "/loadJsonObject", params, this.globalService).pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        try {
          if (data.callSuccess === "1") {
            this.corpNameChangeData = data.jsonObject[0] || {};
            
            this.finalizeDataLoading();
          } else {
            this.body = data.errorMessage || "Failed to load corporation data.";
            this.showF5471ScheduleO = false;
            this.finishApiCall();
          }
        } catch (error) {
          console.error('Error loading corp name change data:', error);
          this.body = "Error loading corporation data.";
          this.showF5471ScheduleO = false;
          this.finishApiCall();
        }
      }, (error) => {
        console.error('API error loading corp name change data:', error);
        this.body = "Error loading corporation data.";
        this.showF5471ScheduleO = false;
        this.finishApiCall();
      });
  }

  finalizeDataLoading() {
    try {
      this.initializeTabData();
      
        this.initializeStatesData();
        
        if (this.scheduleODetailsTemp && this.scheduleODetailsTemp.length > 0) {
          this.processComplexSectionData(this.scheduleODetailsTemp);
        }
        
      this.storeOriginalData();
      
      this.finishApiCall(); // For loadCorpNameChangeData
      this.finishApiCall(); // For loadFilingGroupData  
      this.finishApiCall(); // For loadCountriesData
      this.finishApiCall(); // For loadTabAttributeDetails
      this.finishApiCall(); // For loadScheduleODetails
      this.finishApiCall(); // For checkForEnabled
      
    } catch (error) {
      console.error('Error finalizing data loading:', error);
      this.body = "Error finalizing data loading.";
      this.showF5471ScheduleO = false;
      for (let i = 0; i < 6; i++) {
        this.finishApiCall();
      }
    }
  }

  initializeTabData() {
    // Only initialize if data arrays don't exist or are empty
    // Don't overwrite data that was loaded from API
    if (!this.selectedTabAData || this.selectedTabAData.length === 0) {
      this.selectedTabAData = [];
    }
    if (!this.selectedTabBData || this.selectedTabBData.length === 0) {
      this.selectedTabBData = [];
    }
    if (!this.selectedTabCData || this.selectedTabCData.length === 0) {
      this.selectedTabCData = [];
    }
    if (!this.selectedTabDData || this.selectedTabDData.length === 0) {
      this.selectedTabDData = [];
    }
    if (!this.selectedTabEData || this.selectedTabEData.length === 0) {
      this.selectedTabEData = [];
    }
    if (!this.selectedTab5471Data || this.selectedTab5471Data.length === 0) {
      this.selectedTab5471Data = [];
    }

    // Process main 5471 tab data from tab5471Data
    this.processTab5471Data();
  }

  processTab5471Data() {
    // Process main 5471 tab data similar to original AngularJS logic
    if (this.tab5471Data && this.tab5471Data.length > 0) {
      // Sort by attrib_order - this is the order for form fields
      const dataWithOrder = this.tab5471Data.filter(item => item && typeof item.attrib_order !== 'undefined');
      const sortedData = _.sortBy(dataWithOrder, 'attrib_order');
      
      // AngularJS binds form directly to tab5471Data array
      // We need to ensure tab5471Data has the correct indexes for form binding
      const reorderedData: any[] = [];
      
      // Use consecutive indices instead of attrib_order for form binding
      // Preserve any existing user input when API data loads
      const existingUserInput: {[key: number]: any} = {};
      for (let i = 0; i < this.tab5471Data.length; i++) {
        if (this.tab5471Data[i] && this.tab5471Data[i].VALUE !== undefined) {
          existingUserInput[i] = this.tab5471Data[i].VALUE;
        }
      }
      
      let consecutiveIndex = 0;
      for (const item of sortedData) {
        if (!item) {
          continue;
        }
        
        // Use existing user input if available, otherwise use API value
        let finalValue = item.VALUE;
        if (existingUserInput[consecutiveIndex] !== undefined) {
          finalValue = existingUserInput[consecutiveIndex];
        }
        
        // Store in consecutive order for form binding: [0] = first field, [1] = second field, etc.
        reorderedData[consecutiveIndex] = {
          ...item, // Keep all original properties including metadata
          VALUE: finalValue // Use preserved user input or API value
        };
        consecutiveIndex++;
      }
      
      // Replace tab5471Data with correctly ordered data
      this.tab5471Data = reorderedData;
      
      // Apply any temporary user input that was stored before API loaded
      if (this.tempUserInput && Object.keys(this.tempUserInput).length > 0) {
        for (const indexStr in this.tempUserInput) {
          const index = parseInt(indexStr);
          if (this.tab5471Data[index]) {
            this.tab5471Data[index].VALUE = this.tempUserInput[index];
          }
        }
        // Clear temporary input after applying
        this.tempUserInput = {};
      }
      
      // Also populate selectedTab5471Data for save operations using consecutive indices
      this.selectedTab5471Data = [];
      consecutiveIndex = 0; // Reset counter
      for (const item of sortedData) {
        if (!item) continue;
        
        // Use preserved user input if available, otherwise use API value
        let finalValue = item.VALUE;
        if (existingUserInput[consecutiveIndex] !== undefined) {
          finalValue = existingUserInput[consecutiveIndex];
        }
        
        this.selectedTab5471Data[consecutiveIndex] = {
          VALUE: finalValue, // Use preserved user input or API value
          attrib_name: item.attrib_name,
          attrib_description: item.attrib_description,
          line_attrib_key: item.line_attrib_key,
          // Preserve all metadata needed for save
          trans_type_key: item.trans_type_key,
          form_key: item.form_key,
          line_no: item.line_no,
          occurrence: item.occurrence,
          trans_details_key: item.trans_details_key
        };
        consecutiveIndex++;
      }
    }
  }

  initializeStatesData() {
    // Initialize US states data - similar to original AngularJS
    this.states = [
      { code: 'AL', name: 'Alabama' },
      { code: 'AK', name: 'Alaska' },
      { code: 'AZ', name: 'Arizona' },
      { code: 'AR', name: 'Arkansas' },
      { code: 'CA', name: 'California' },
      { code: 'CO', name: 'Colorado' },
      { code: 'CT', name: 'Connecticut' },
      { code: 'DE', name: 'Delaware' },
      { code: 'FL', name: 'Florida' },
      { code: 'GA', name: 'Georgia' },
      { code: 'HI', name: 'Hawaii' },
      { code: 'ID', name: 'Idaho' },
      { code: 'IL', name: 'Illinois' },
      { code: 'IN', name: 'Indiana' },
      { code: 'IA', name: 'Iowa' },
      { code: 'KS', name: 'Kansas' },
      { code: 'KY', name: 'Kentucky' },
      { code: 'LA', name: 'Louisiana' },
      { code: 'ME', name: 'Maine' },
      { code: 'MD', name: 'Maryland' },
      { code: 'MA', name: 'Massachusetts' },
      { code: 'MI', name: 'Michigan' },
      { code: 'MN', name: 'Minnesota' },
      { code: 'MS', name: 'Mississippi' },
      { code: 'MO', name: 'Missouri' },
      { code: 'MT', name: 'Montana' },
      { code: 'NE', name: 'Nebraska' },
      { code: 'NV', name: 'Nevada' },
      { code: 'NH', name: 'New Hampshire' },
      { code: 'NJ', name: 'New Jersey' },
      { code: 'NM', name: 'New Mexico' },
      { code: 'NY', name: 'New York' },
      { code: 'NC', name: 'North Carolina' },
      { code: 'ND', name: 'North Dakota' },
      { code: 'OH', name: 'Ohio' },
      { code: 'OK', name: 'Oklahoma' },
      { code: 'OR', name: 'Oregon' },
      { code: 'PA', name: 'Pennsylvania' },
      { code: 'RI', name: 'Rhode Island' },
      { code: 'SC', name: 'South Carolina' },
      { code: 'SD', name: 'South Dakota' },
      { code: 'TN', name: 'Tennessee' },
      { code: 'TX', name: 'Texas' },
      { code: 'UT', name: 'Utah' },
      { code: 'VT', name: 'Vermont' },
      { code: 'VA', name: 'Virginia' },
      { code: 'WA', name: 'Washington' },
      { code: 'WV', name: 'West Virginia' },
      { code: 'WI', name: 'Wisconsin' },
      { code: 'WY', name: 'Wyoming' },
      { code: 'DC', name: 'District of Columbia' }
    ];
  }

  storeOriginalData() {
    try {
      this.tab5471OriginalData = safeJsonInput<any>(JSON.stringify(this.tab5471Data), null, 'fir-5471-schedule-o.parse1');
      this.selectedTabAOriginalData = safeJsonInput<any>(JSON.stringify(this.selectedTabAData), null, 'fir-5471-schedule-o.parse2');
      this.selectedTabBOriginalData = safeJsonInput<any>(JSON.stringify(this.selectedTabBData), null, 'fir-5471-schedule-o.parse3');
      this.selectedTabCOriginalData = safeJsonInput<any>(JSON.stringify(this.selectedTabCData), null, 'fir-5471-schedule-o.parse4');
      this.selectedTabDOriginalData = safeJsonInput<any>(JSON.stringify(this.selectedTabDData), null, 'fir-5471-schedule-o.parse5');
      this.selectedTabEOriginalData = safeJsonInput<any>(JSON.stringify(this.selectedTabEData), null, 'fir-5471-schedule-o.parse6');
    } catch (error) {
      console.error('Error storing original data:', error);
    }
  }

  processScheduleOData(jsonObject: any[]) {
    try {
      // Process the main Schedule O data similar to original AngularJS
      if (jsonObject && jsonObject.length > 0) {
        // Store the raw data for further processing
        this.scheduleODetailsTemp = jsonObject;
        
        this.processComplexSectionData(jsonObject);
      } else {
        console.log('No jsonObject data to process - this is why sections are empty!');
      }
    } catch (error) {
      console.error('Error processing Schedule O data:', error);
    }
  }

  processComplexSectionData(jsonObject: any[]) {
    try {
      this.sectionAData = [];
      this.sectionBData = [];
      this.sectionCData = [];
      this.sectionDData = [];
      this.sectionEData = [];
      this.tab5471Data = [];
      
      let i = 1;
      while (i < jsonObject.length) {
        const tempAttribValue = jsonObject[i].attrib_value;
        const strArray = tempAttribValue.split("~");
        
        if (strArray[0] !== 'LINE_NO') {
          const line_no = strArray[3];
          let j = i;
          let index = 0;
          const tempObj: any[] = [];
          let countryUSFlag = false;
          const pre_occurrence = jsonObject[j].object_id.split("~")[4];
          const pre_line_no = jsonObject[i].line_no;
          
          // Process items with same occurrence and line_no
          while (j < jsonObject.length && 
                 pre_occurrence === jsonObject[j].object_id.split("~")[4] && 
                 pre_line_no === jsonObject[j].line_no) {
            
            const attrib_details = jsonObject[j].attrib_value;
            const detailsArr = attrib_details.split("~");
            const object_details = jsonObject[j].object_id;
            const objectArr = object_details.split("~");
            
            
            if (pre_line_no !== '4' && objectArr[4] !== "0") {
              // Process non-main tab data (sections A-E)
              let value = jsonObject[j].VALUE || null;
              
              // Set country flag BEFORE processing special fields (EXACT AngularJS replication)
              if ((detailsArr[0] === "COUNTRY" || detailsArr[0] === "5471_O_US_PER_OFF_DIR_F_COUNTRY") && value === "US") {
                countryUSFlag = true;
              }
              
              value = this.processSpecialFields(detailsArr[0], value, countryUSFlag);
              
              tempObj[index] = {
                trans_type_key: objectArr[1],
                attrib_name: detailsArr[0],
                line_attrib_key: detailsArr[1],
                trans_details_key: objectArr[3],
                occurrence: objectArr[4],
                attrib_description: detailsArr[3],
                form_key: objectArr[6],
                line_no: pre_line_no,
                VALUE: value,
                attrib_order: parseInt(detailsArr[4] || '0'),
                updated_by: jsonObject[j].updated_by || null,
                updated_on: jsonObject[j].updated_on || null
              };
              index++;
            } else if (pre_line_no === '4' || pre_line_no === 4) {
              // Process main 5471 tab data - handle both string and number
              let value = jsonObject[j].VALUE || null;
              
              // Handle date fields - convert to YYYY-MM-DD format for HTML date input
              if (detailsArr[0] === "REORGANIZATION_DATE" && value) {
                const dateSet = parseAsLocalDate(String(value));
                if (dateSet) {
                  const year = dateSet.getFullYear();
                  const month = String(dateSet.getMonth() + 1).padStart(2, '0');
                  const day = String(dateSet.getDate()).padStart(2, '0');
                  value = `${year}-${month}-${day}`;
                }
              }
              
              this.tab5471Data.push({
                trans_type_key: objectArr[1],
                attrib_name: detailsArr[0],
                line_attrib_key: detailsArr[1],
                trans_details_key: objectArr[3],
                occurrence: objectArr[4],
                attrib_description: detailsArr[3],
                form_key: objectArr[6],
                line_no: pre_line_no,
                VALUE: value,
                attrib_order: parseInt(detailsArr[4] || '0'),
                updated_by: jsonObject[j].updated_by || null,
                updated_on: jsonObject[j].updated_on || null
              });
            }
            j++;
          }
          
          // Add section data to appropriate arrays
          if (tempObj.length > 0 && pre_line_no !== '4') {
            switch (pre_line_no) {
              case '1':
                  this.sectionCData.push(tempObj);
                  break;
              case '2':
                this.sectionDData.push(tempObj);
                break;
              case '3':
                this.sectionEData.push(tempObj);
                break;
              case '5':
                this.sectionAData.push(tempObj);
                break;
              case '6':
                this.sectionBData.push(tempObj);
                break;
              default:
            }
          } else if (pre_line_no !== '4') {
          }
          i = j;
        } else {
          i++;
        }
      }
      
      // Sort section data by attrib_order
      this.sortSectionData();
      
      
    } catch (error) {
      console.error('Error processing complex section data:', error);
    }
  }
  
  processSpecialFields(attribName: string, value: any, countryUSFlag: boolean): any {

    if ((attribName === "NAME_OF_SHAREHOLDER_FILING" || attribName === "NAME_OF_SHAREHOLDER_DISPOSING") && value) {

      if (typeof value === 'string' && this.filingGroup && this.filingGroup.length > 0) {
        
        let entityObject = this.filingGroup.find(item => item.LEGAL_ENTITY_ID === value);
        
        if (!entityObject) {
          entityObject = this.filingGroup.find(item => item.LEID === value);
        }
        
        if (entityObject) {
          return entityObject;
        }
      }
      return value;
    }
    
    if ((attribName === "COUNTRY" || attribName === "5471_O_US_PER_OFF_DIR_F_COUNTRY") && value) {
      return this.getCountryInfo(value);
    }
    
    if ((attribName === "STATE" || attribName === "5471_O_US_PER_OFF_DIR_US_STATE" || attribName === "5471_O_US_PER_OFF_DIR_F_STATE" || attribName === "5471_O_STOCK_ACQ_F_STATE" || attribName === "5471_O_STOCK_DIS_F_STATE" || attribName === "5471_O_ORG_REORG_F_STATE") && value) {
      if (value === "[object Object]") {
        return null;
      }
      
      // For Section B, always transform state codes to state objects (they handle US/Foreign in the template)
      if (attribName === "5471_O_US_PER_OFF_DIR_US_STATE" || attribName === "5471_O_US_PER_OFF_DIR_F_STATE") {
        const stateObject = this.getStateInfo(value);
        return stateObject;
      }
      // For other sections, use country flag logic
      else if (countryUSFlag) {
        const stateObject = this.getStateInfo(value);
        return stateObject;
      } else {
        return value;
      }
    }
    
    // Handle numeric fields
    const numericFields = [
      "NUMBER_OF_DIRECTLY_SHARES_ACQUIRED", "NUMBER_OF_INDIRECTLY_SHARES_ACQUIRED",
      "NUMBER_OF_CONSTRUCTIVELY_SHARES_ACQUIRED", "AMT_PAID_OR_VALUE_GIVEN",
      "NUMBER_OF_DIRECTLY_SHARES_DISPOSED", "NUMBER_OF_INDIRECTLY_SHARES_DISPOSED",
      "NUMBER_OF_CONSTRUCTIVELY_SHARES_DISPOSED", "AMT_RECEIVED",
      "FAIR_MARKET_VALUE", "ADJUST_BASIS"
    ];
    
    if (numericFields.includes(attribName)) {
      return value ? parseInt(value) : 0;
    }
    
    // Handle boolean fields
    if (attribName === "CORPORATION_NAME_CHANGE") {
      return value ? (value === 'true') : false;
    }
    
    // Handle identifying number
    if (attribName === "IDENTIFYING_NUMBER" && value) {
      return value; // Return as-is for now
    }
    
    return value;
  }
  
  getCountryInfo(countryCode: string): any {
    // Find country from loaded countries data
    if (this.countries && this.countries.length > 0) {
      return this.countries.find(c => c.COUNTRY_CODE === countryCode) || countryCode;
    }
    return countryCode;
  }
  
  // EXACT AngularJS replication: vm.getStateInfo(stateCode)
  getStateInfo(stateCode: string): any {
    
    // Find state from loaded states data
    if (this.states && this.states.length > 0) {
      const stateObject = this.states.find(s => s.code === stateCode);
      if (stateObject) {
        return stateObject;
      } 
    } 
  
    return stateCode; // Return as-is if not found
  }
  
  // 🔧 NEW: Map between US and Foreign field names for Section B edit
  mapFieldName(formFieldName: string): string | null {
    const fieldMappings: { [key: string]: string } = {
      // Form field (Foreign) → Saved field (US)
      '5471_O_US_PER_OFF_DIR_F_ADDR_1': '5471_O_US_PER_OFF_DIR_US_ADDR_1',
      '5471_O_US_PER_OFF_DIR_F_ADDR_2': '5471_O_US_PER_OFF_DIR_US_ADDR_2',
      '5471_O_US_PER_OFF_DIR_F_CITY': '5471_O_US_PER_OFF_DIR_US_CITY',
      '5471_O_US_PER_OFF_DIR_F_STATE': '5471_O_US_PER_OFF_DIR_US_STATE',
      '5471_O_US_PER_OFF_DIR_F_ZIP': '5471_O_US_PER_OFF_DIR_US_ZIP',
      
      // Reverse mapping (US → Foreign) - in case needed
      '5471_O_US_PER_OFF_DIR_US_ADDR_1': '5471_O_US_PER_OFF_DIR_F_ADDR_1',
      '5471_O_US_PER_OFF_DIR_US_ADDR_2': '5471_O_US_PER_OFF_DIR_F_ADDR_2',
      '5471_O_US_PER_OFF_DIR_US_CITY': '5471_O_US_PER_OFF_DIR_F_CITY',
      '5471_O_US_PER_OFF_DIR_US_STATE': '5471_O_US_PER_OFF_DIR_F_STATE',
      '5471_O_US_PER_OFF_DIR_US_ZIP': '5471_O_US_PER_OFF_DIR_F_ZIP'
    };
    
    return fieldMappings[formFieldName] || null;
  }
  
  sortSectionData() {
    // Sort each section's data by attrib_order
    for (let m = 0; m < this.sectionAData.length; m++) {
      this.sectionAData[m] = _.sortBy(this.sectionAData[m], 'attrib_order');
    }
    for (let m = 0; m < this.sectionBData.length; m++) {
      this.sectionBData[m] = _.sortBy(this.sectionBData[m], 'attrib_order');
    }
    for (let m = 0; m < this.sectionCData.length; m++) {
      this.sectionCData[m] = _.sortBy(this.sectionCData[m], 'attrib_order');
    }
    for (let m = 0; m < this.sectionDData.length; m++) {
      this.sectionDData[m] = _.sortBy(this.sectionDData[m], 'attrib_order');
    }
    for (let m = 0; m < this.sectionEData.length; m++) {
      this.sectionEData[m] = _.sortBy(this.sectionEData[m], 'attrib_order');
    }
    
    // Sort main tab data
    this.tab5471Data = _.sortBy(this.tab5471Data, 'attrib_order');
  }
  
  // Validation utility methods
  private toLocalDate(value: any): Date | null {
    if (!value) return null;
    if (value instanceof Date) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }
    const parsed = parseAsLocalDate(String(value));
    if (parsed) return parsed;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  private isDateInRange(dateValue: string | Date): boolean {
    if (!dateValue || !this.rowData.TAX_YEAR_BEGIN || !this.rowData.TAX_YEAR_END) {
      return true;
    }
    
    const date = this.toLocalDate(dateValue);
    const taxYearBegin = this.toLocalDate(this.rowData.TAX_YEAR_BEGIN);
    const taxYearEnd = this.toLocalDate(this.rowData.TAX_YEAR_END);
    
    if (!date || !taxYearBegin || !taxYearEnd) return true;
    
    return date >= taxYearBegin && date <= taxYearEnd;
  }

  // Main 5471 reorganization date must fall within the last 4 years ending on the tax year end date
  private isWithinLast4Years(dateValue: string | Date): boolean {
    if (!dateValue || !this.rowData.TAX_YEAR_END) {
      return true;
    }

    const date = this.toLocalDate(dateValue);
    const taxYearEnd = this.toLocalDate(this.rowData.TAX_YEAR_END);

    if (!date || !taxYearEnd) return true;

    const fourYearsBeforeEnd = new Date(taxYearEnd.getFullYear() - 4, taxYearEnd.getMonth(), taxYearEnd.getDate());

    return date >= fourYearsBeforeEnd && date <= taxYearEnd;
  }

  // Formats the start of the last-4-years window (tax year end minus 4 years) for validation messages
  private formatLast4YearsStart(): string {
    const taxYearEnd = this.toLocalDate(this.rowData.TAX_YEAR_END);
    if (!taxYearEnd) return '';
    const fourYearsBeforeEnd = new Date(taxYearEnd.getFullYear() - 4, taxYearEnd.getMonth(), taxYearEnd.getDate());
    return fourYearsBeforeEnd.toLocaleDateString('en-US');
  }
  
  private validateAlphaNumeric(value: string): boolean {
    if (!value) return true; // Empty is valid (checked by required validation)
    // Basic alphanumeric validation - letters, numbers, spaces, common punctuation
    const alphaNumericRegex = /^[a-zA-Z0-9\s\.,\-\(\)]+$/;
    return alphaNumericRegex.test(value);
  }
  
  private validateNumericField(value: any): boolean {
    if (!value && value !== 0) return true; // Empty is valid (checked by required validation)
    return !isNaN(Number(value)) && isFinite(Number(value));
  }
  
  private validateZipCode(value: string, countryCode: string): boolean {
    if (!value) return true; // Empty is valid (checked by required validation)
    if (countryCode === 'US') {
      // US zip code - only numbers
      return /^[0-9]*$/.test(value);
    }
    return true; // Non-US postal codes can be alphanumeric
  }
  
  private setValidationError(fieldKey: string, errorMessage: string) {
    this.validationErrors[fieldKey] = errorMessage;
  }
  
  private clearValidationError(fieldKey: string) {
    delete this.validationErrors[fieldKey];
  }
  
  // Public methods for template access
  hasValidationError(fieldKey: string): boolean {
    return !!this.validationErrors[fieldKey];
  }
  
  getValidationError(fieldKey: string): string {
    return this.validationErrors[fieldKey] || '';
  }
  
  processSectionData(jsonObject: any[]) {
    // Keep the simple version as backup
    try {
      // Initialize section arrays
      this.sectionAData = [];
      this.sectionBData = [];
      this.sectionCData = [];
      this.sectionDData = [];
      this.sectionEData = [];
      
      // Process data for each section based on section_code
      for (const item of jsonObject) {
        switch (item.section_code) {
          case 'A':
            this.sectionAData.push(item);
            break;
          case 'B':
            this.sectionBData.push(item);
            break;
         case 'C':
           this.sectionCData.push(item);
           break;
          case 'D':
            this.sectionDData.push(item);
            break;
          case 'E':
            this.sectionEData.push(item);
            break;
          default:
            this.tab5471Data.push(item);
            break;
        }
      }
    } catch (error) {
      console.error('Error processing section data:', error);
    }
  }

  processTabAttributeDetails(tabAttribDetails: any[]) {
    try {
      
      if (tabAttribDetails && tabAttribDetails.length > 0) {
        
        const attrib = tabAttribDetails[0];
        const parsedAttrib = typeof attrib === 'string' ? safeJsonInput<any>(attrib, null, 'fir-5471-schedule-o.parse7') : attrib;
        
        if (parsedAttrib.LINE1_ATTRIB) {
          let tabCData;
          if (typeof parsedAttrib.LINE1_ATTRIB === 'string') {
            tabCData = safeJsonInput<any>(parsedAttrib.LINE1_ATTRIB, null, 'fir-5471-schedule-o.parse8');
          } else {
            tabCData = parsedAttrib.LINE1_ATTRIB;
          }
          
          this.processLineAttributes('C', tabCData);
        } else {
          console.warn('LINE1_ATTRIB (Section C) is missing from API response!');
        }
        
        // Process LINE2_ATTRIB for Section D
        if (parsedAttrib.LINE2_ATTRIB) {
          let tabDData = typeof parsedAttrib.LINE2_ATTRIB === 'string' ? 
            safeJsonInput<any>(parsedAttrib.LINE2_ATTRIB, null, 'fir-5471-schedule-o.parse9') : parsedAttrib.LINE2_ATTRIB;
          this.processLineAttributes('D', tabDData);
        }
        
        // Process LINE3_ATTRIB for Section E
        if (parsedAttrib.LINE3_ATTRIB) {
          let tabEData = typeof parsedAttrib.LINE3_ATTRIB === 'string' ? 
            safeJsonInput<any>(parsedAttrib.LINE3_ATTRIB, null, 'fir-5471-schedule-o.parse10') : parsedAttrib.LINE3_ATTRIB;
          this.processLineAttributes('E', tabEData);
        }
        
        // Process LINE6_ATTRIB for Section B
        if (parsedAttrib.LINE6_ATTRIB) {
          let tabBData;
          if (typeof parsedAttrib.LINE6_ATTRIB === 'string') {
            tabBData = safeJsonInput<any>(parsedAttrib.LINE6_ATTRIB, null, 'fir-5471-schedule-o.parse11');
          } else {
            tabBData = parsedAttrib.LINE6_ATTRIB;
          }
          
          this.processLineAttributes('B', tabBData);
        } else {
          console.warn('LINE6_ATTRIB (Section B) is missing from API response!');
        }
        
        // Process LINE5_ATTRIB for Section A
        if (parsedAttrib.LINE5_ATTRIB) {
          let tabAData;
          if (typeof parsedAttrib.LINE5_ATTRIB === 'string') {
            tabAData = safeJsonInput<any>(parsedAttrib.LINE5_ATTRIB, null, 'fir-5471-schedule-o.parse12');
          } else {
            tabAData = parsedAttrib.LINE5_ATTRIB;
          }
          
          this.processLineAttributes('A', tabAData);
        }
      } else {
        console.log('No tabAttribDetails data received');
      }
    } catch (error) {
      console.error('Error processing tab attribute details:', error);
    }
  }

  processLineAttributes(section: string, lineAttrib: any[]) {
    try {
      // Process line attributes for each section
      if (lineAttrib && Array.isArray(lineAttrib) && lineAttrib.length > 0) {
        switch (section) {
          case 'A':
            if (!this.selectedTabAData || this.selectedTabAData.length === 0) {
              if (Array.isArray(lineAttrib)) {
                this.selectedTabAData = lineAttrib.map(item => ({
                  ...item,
                  occurrence: null,
                  trans_details_key: null,
                  VALUE: null
                }));
              } else {
                console.warn('lineAttrib is not an array for section A:', lineAttrib);
                this.selectedTabAData = [];
              }
            }
            break;
          case 'B':
            if (!this.selectedTabBData || this.selectedTabBData.length === 0) {
              if (Array.isArray(lineAttrib) && lineAttrib.length > 0) {
                this.tabBAttribDetails = [...lineAttrib];
                
                const transformedData = [];
                let tabb_index = 0;
                
                for (let i = 0; i < lineAttrib.length; i++) {
                  const metadata = lineAttrib[i];
                  
                  if (metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_ADDR_1' &&
                      metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_ADDR_2' &&
                      metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_CITY' &&
                      metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_STATE' &&
                      metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_ZIP') {
                    
                    console.log(`Adding field ${tabb_index}: ${metadata.attrib_name}`);
                    
                    const value = null;
                    transformedData[tabb_index] = {
                      "line_no": metadata.line_no,                   
                      "line_attrib_key": metadata.line_attrib_key,    
                      "attrib_name": metadata.attrib_name,            
                      "attrib_description": metadata.attrib_description, 
                      "form_key": metadata.form_key,                  
                      "trans_details_key": null,                      
                      "occurrence": null,                            
                      "VALUE": value,                                
                      "trans_type_key": metadata.trans_type_key      
                    };
                    tabb_index++;
                  }
                }
                
                this.selectedTabBData = transformedData;
                this.selectedTabBData.forEach((item, index) => {
                });
              } else {
                this.selectedTabBData = [];
              }
            }
            break;
          case 'C':
            if (!this.selectedTabCData || this.selectedTabCData.length === 0) {
              if (Array.isArray(lineAttrib)) {
                this.tabCAttribDetails = [...lineAttrib];
                const transformedData = [];
                let tabc_index = 0;
                
                for (let i = 0; i < lineAttrib.length; i++) {
                  const metadata = lineAttrib[i];
                  
                  if (metadata.attrib_name !== 'ADDRESS_LINE_1' &&
                      metadata.attrib_name !== 'ADDRESS_LINE_2' &&
                      metadata.attrib_name !== 'CITY' &&
                      metadata.attrib_name !== 'STATE' &&
                      metadata.attrib_name !== 'ZIP_POSTAL_CODE' &&
                      metadata.attrib_name !== '5471_O_STOCK_ACQ_SH_NAME_1' &&
                      metadata.attrib_name !== '5471_O_STOCK_ACQ_SH_NAME_2' &&
                      metadata.attrib_name !== '5471_O_STOCK_ACQ_PERSON_NAME') {
                    
                    let value = null;
                    
                    if (metadata.attrib_name === 'NUMBER_OF_DIRECTLY_SHARES_ACQUIRED' ||
                        metadata.attrib_name === 'NUMBER_OF_CONSTRUCTIVELY_SHARES_ACQUIRED' ||
                        metadata.attrib_name === 'NUMBER_OF_INDIRECTLY_SHARES_ACQUIRED' ||
                        metadata.attrib_name === 'AMT_PAID_OR_VALUE_GIVEN') {
                      value = 0;
                    } else if (metadata.attrib_name === 'PERSON_BUSINESS_VALUE') {
                      value = "B";
                    } else if (metadata.attrib_name === 'NAME_OF_SHAREHOLDER_FILING') {
                      value = {};
                    }
                    
                    transformedData[tabc_index] = {
                      line_no: metadata.line_no,
                      line_attrib_key: metadata.line_attrib_key,
                      attrib_name: metadata.attrib_name,
                      attrib_description: metadata.attrib_description,
                      form_key: metadata.form_key,
                      trans_details_key: null,
                      occurrence: null,
                      VALUE: value,
                      trans_type_key: metadata.trans_type_key
                    };
                    tabc_index++;
                  }
                }
                
                this.selectedTabCData = transformedData;
              } else {
                console.warn('lineAttrib is not an array for section C:', lineAttrib);
                this.selectedTabCData = [];
              }
            }
            break;
          case 'D':
            if (!this.selectedTabDData || this.selectedTabDData.length === 0) {
              
              if (Array.isArray(lineAttrib)) {
                this.tabDAttribDetails = [...lineAttrib];
                const transformedData = [];
                let tabd_index = 0;
                
                for (let i = 0; i < lineAttrib.length; i++) {
                  const metadata = lineAttrib[i];
                  
                  if (metadata.attrib_name !== 'ADDRESS_LINE_1' &&
                      metadata.attrib_name !== 'ADDRESS_LINE_2' &&
                      metadata.attrib_name !== 'CITY' &&
                      metadata.attrib_name !== 'STATE' &&
                      metadata.attrib_name !== 'ZIP_POSTAL_CODE' &&
                      metadata.attrib_name !== '5471_O_STOCK_DIS_SH_NAME_1' &&
                      metadata.attrib_name !== '5471_O_STOCK_DIS_SH_NAME_2' &&
                      metadata.attrib_name !== '5471_O_STOCK_DIS_PERSON_NAME') {
                    
                    let value = null;
                    
                    if (metadata.attrib_name === 'NUMBER_OF_DIRECTLY_SHARES_DISPOSED' ||
                        metadata.attrib_name === 'NUMBER_OF_INDIRECTLY_SHARES_DISPOSED' ||
                        metadata.attrib_name === 'NUMBER_OF_CONSTRUCTIVELY_SHARES_DISPOSED' ||
                        metadata.attrib_name === 'AMT_RECEIVED') {
                      value = 0;
                    } else if (metadata.attrib_name === 'PERSON_BUSINESS_VALUE') {
                      value = "B";
                    } else if (metadata.attrib_name === 'NAME_OF_SHAREHOLDER_DISPOSING') {
                      value = {};
                    }
                    
                    transformedData[tabd_index] = {
                      line_no: metadata.line_no,
                      line_attrib_key: metadata.line_attrib_key,
                      attrib_name: metadata.attrib_name,
                      attrib_description: metadata.attrib_description,
                      form_key: metadata.form_key,
                      trans_details_key: null,
                      occurrence: null,
                      VALUE: value,
                      trans_type_key: metadata.trans_type_key
                    };
                    tabd_index++;
                  }
                }
                
                this.selectedTabDData = transformedData;
              } else {
                console.warn('lineAttrib is not an array for section D:', lineAttrib);
                this.selectedTabDData = [];
              }
            }
            break;
          case 'E':
            
            if (!this.selectedTabEData || this.selectedTabEData.length === 0) {
              if (Array.isArray(lineAttrib)) {
               
                this.tabEAttribDetails = [...lineAttrib];
               
                const transformedData = [];
                let tabe_index = 0;
                
                for (let i = 0; i < lineAttrib.length; i++) {
                  const metadata = lineAttrib[i];
                  
                  if (metadata.attrib_name !== 'ADDRESS_LINE_1' &&
                      metadata.attrib_name !== 'ADDRESS_LINE_2' &&
                      metadata.attrib_name !== 'CITY' &&
                      metadata.attrib_name !== 'STATE' &&
                      metadata.attrib_name !== 'ZIP_POSTAL_CODE' &&
                      metadata.attrib_name !== '5471_O_ORG_REORG_DATE' &&
                      metadata.attrib_name !== '5471_O_ORG_REORG_SSN') {
                    
                    let value = null;
                    
                    if (metadata.attrib_name === 'FAIR_MARKET_VALUE' ||
                        metadata.attrib_name === 'ADJUST_BASIS') {
                      value = 0;
                    } else if (metadata.attrib_name === 'PERSON_BUSINESS_VALUE') {
                      value = 'B';
                    } else if (metadata.attrib_name === 'CORPORATION_NAME_CHANGE') {
                      value = false;
                    }
                    
                    transformedData[tabe_index] = {
                      line_no: metadata.line_no,
                      line_attrib_key: metadata.line_attrib_key,
                      attrib_name: metadata.attrib_name,
                      attrib_description: metadata.attrib_description,
                      form_key: metadata.form_key,
                      trans_details_key: null,
                      occurrence: null,
                      VALUE: value,
                      DISVALUE: value, 
                      trans_type_key: metadata.trans_type_key
                    };
                    tabe_index++;
                  }
                }
                
                this.selectedTabEData = transformedData;
              } else {
                console.warn('lineAttrib is not an array for section E:', lineAttrib);
                this.selectedTabEData = [];
              }
            }
            break;
        }
      }
    } catch (error) {
      console.error('Error processing line attributes for section', section, ':', error);
      console.error('lineAttrib type:', typeof lineAttrib);
      console.error('lineAttrib value:', lineAttrib);
      console.error('lineAttrib is array:', Array.isArray(lineAttrib));
    }
  }

  private initializeAllSectionsAfterApiLoad() {
    if (!this.selectedTabBData || this.selectedTabBData.length === 0) {
      this.selectedTabBData = [];
    }
    if (!this.selectedTabCData || this.selectedTabCData.length === 0) {
      this.selectedTabCData = [];
    }
    if (!this.selectedTabDData || this.selectedTabDData.length === 0) {
      this.selectedTabDData = [];
    }
    if (!this.selectedTabEData || this.selectedTabEData.length === 0) {
      this.selectedTabEData = [];
    }
  }

  onTabChange(tabName: string) {
    switch (tabName) {
      case 'Add new Section A':
        if (!this.selectedTabAData || this.selectedTabAData.length === 0) {
          this.initializeSectionAData();
        }
        break;
      case 'Add new Section B':
        if (!this.selectedTabBData || this.selectedTabBData.length === 0) {
          this.initializeSectionBData();
        }
        break;
      case 'Add new Stock Acquisition':
        if (!this.selectedTabCData || this.selectedTabCData.length === 0) {
          this.initializeSectionCData();
        }
        break;
      case 'Add new Stock Disposition':
        if (!this.selectedTabDData || this.selectedTabDData.length === 0) {
          this.initializeSectionDData();
        }
        break;
      case 'Add new Reorganization Information':
        if (!this.selectedTabEData || this.selectedTabEData.length === 0) {
          this.initializeSectionEData();
        }
        break;
    }
  }

  private initializeSectionAData() {
    // Section A should be initialized by processLineAttributes when API data loads
    if (!this.selectedTabAData || this.selectedTabAData.length === 0) {
      
      return;
    } else {
      if (this.selectedTabAData.length > 0 && !this.selectedTabAData[0].hasOwnProperty('VALUE')) {
        
        const transformedData = this.selectedTabAData.map((metadata, index) => ({
          ...metadata,
          trans_details_key: null,
          occurrence: null,
          VALUE: null
        }));
        
        this.selectedTabAData = transformedData;
      }
    }
  }

  private initializeSectionBData() {
    const source = (this.selectedTabBData && this.selectedTabBData.length > 0)
      ? this.selectedTabBData
      : this.tabBAttribDetails;

    if (!source || source.length === 0) {
      return;
    }

    const needsTransform = !source[0]?.hasOwnProperty('VALUE');
    if (!needsTransform && this.selectedTabBData.length > 0) {
      return;
    }

    const transformedData: any[] = [];
    let index = 0;

    for (let i = 0; i < source.length; i++) {
      const metadata = source[i];
      if (!metadata) continue;

      if (metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_ADDR_1' &&
          metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_ADDR_2' &&
          metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_CITY' &&
          metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_STATE' &&
          metadata.attrib_name !== '5471_O_US_PER_OFF_DIR_US_ZIP') {

        transformedData[index] = {
          ...metadata,
          trans_details_key: null,
          occurrence: null,
          VALUE: null
        };
        index++;
      }
    }

    this.selectedTabBData = transformedData;
  }

  private initializeSectionCData() {
    const source = (this.selectedTabCData && this.selectedTabCData.length > 0)
      ? this.selectedTabCData
      : this.tabCAttribDetails;

    if (!source || source.length === 0) {
      return;
    }

    const needsTransform = !source[0]?.hasOwnProperty('VALUE');
    if (!needsTransform && this.selectedTabCData.length > 0) {
      return;
    }

    const transformedData: any[] = [];
    let index = 0;

    for (let i = 0; i < source.length; i++) {
      const metadata = source[i];
      if (!metadata) continue;

      if (metadata.attrib_name !== 'ADDRESS_LINE_1' &&
          metadata.attrib_name !== 'ADDRESS_LINE_2' &&
          metadata.attrib_name !== 'CITY' &&
          metadata.attrib_name !== 'STATE' &&
          metadata.attrib_name !== 'ZIP_POSTAL_CODE' &&
          metadata.attrib_name !== '5471_O_STOCK_ACQ_SH_NAME_1' &&
          metadata.attrib_name !== '5471_O_STOCK_ACQ_SH_NAME_2' &&
          metadata.attrib_name !== '5471_O_STOCK_ACQ_PERSON_NAME') {

        let defaultValue: any = null;
        if (metadata.attrib_name === 'NUMBER_OF_DIRECTLY_SHARES_ACQUIRED' ||
            metadata.attrib_name === 'NUMBER_OF_CONSTRUCTIVELY_SHARES_ACQUIRED' ||
            metadata.attrib_name === 'NUMBER_OF_INDIRECTLY_SHARES_ACQUIRED' ||
            metadata.attrib_name === 'AMT_PAID_OR_VALUE_GIVEN') {
          defaultValue = 0;
        } else if (metadata.attrib_name === 'PERSON_BUSINESS_VALUE') {
          defaultValue = "B";
        } else if (metadata.attrib_name === 'NAME_OF_SHAREHOLDER_FILING') {
          defaultValue = {};
        }

        transformedData[index] = {
          ...metadata,
          trans_details_key: null,
          occurrence: null,
          VALUE: defaultValue
        };
        index++;
      }
    }

    this.selectedTabCData = transformedData;
  }

  private initializeSectionDData() {
    const source = (this.selectedTabDData && this.selectedTabDData.length > 0)
      ? this.selectedTabDData
      : this.tabDAttribDetails;

    if (!source || source.length === 0) {
      return;
    }

    const needsTransform = !source[0]?.hasOwnProperty('VALUE');
    if (!needsTransform && this.selectedTabDData.length > 0) {
      return;
    }

    const transformedData: any[] = [];
    let index = 0;

    for (let i = 0; i < source.length; i++) {
      const metadata = source[i];
      if (!metadata) continue;

      if (metadata.attrib_name !== 'ADDRESS_LINE_1' &&
          metadata.attrib_name !== 'ADDRESS_LINE_2' &&
          metadata.attrib_name !== 'CITY' &&
          metadata.attrib_name !== 'STATE' &&
          metadata.attrib_name !== 'ZIP_POSTAL_CODE' &&
          metadata.attrib_name !== '5471_O_STOCK_DIS_SH_NAME_1' &&
          metadata.attrib_name !== '5471_O_STOCK_DIS_SH_NAME_2' &&
          metadata.attrib_name !== '5471_O_STOCK_DIS_PERSON_NAME') {

        let defaultValue: any = null;
        if (metadata.attrib_name === 'NUMBER_OF_DIRECTLY_SHARES_DISPOSED' ||
            metadata.attrib_name === 'NUMBER_OF_CONSTRUCTIVELY_SHARES_DISPOSED' ||
            metadata.attrib_name === 'NUMBER_OF_INDIRECTLY_SHARES_DISPOSED' ||
            metadata.attrib_name === 'AMT_RECEIVED') {
          defaultValue = 0;
        } else if (metadata.attrib_name === 'PERSON_BUSINESS_VALUE') {
          defaultValue = "B";
        } else if (metadata.attrib_name === 'NAME_OF_SHAREHOLDER_DISPOSING') {
          defaultValue = {};
        }

        transformedData[index] = {
          ...metadata,
          trans_details_key: null,
          occurrence: null,
          VALUE: defaultValue
        };
        index++;
      }
    }

    this.selectedTabDData = transformedData;
  }

  private initializeSectionEData() {
    const source = (this.selectedTabEData && this.selectedTabEData.length > 0)
      ? this.selectedTabEData
      : this.tabEAttribDetails;

    if (!source || source.length === 0) {
      return;
    }

    const needsTransform = !source[0]?.hasOwnProperty('VALUE');
    if (!needsTransform && this.selectedTabEData.length > 0) {
      return;
    }

    const transformedData: any[] = [];
    let index = 0;

    for (let i = 0; i < source.length; i++) {
      const metadata = source[i];
      if (!metadata) continue;

      if (metadata.attrib_name !== 'ADDRESS_LINE_1' &&
          metadata.attrib_name !== 'ADDRESS_LINE_2' &&
          metadata.attrib_name !== 'CITY' &&
          metadata.attrib_name !== 'STATE' &&
          metadata.attrib_name !== 'ZIP_POSTAL_CODE') {

        let defaultValue: any = null;
        if (metadata.attrib_name === 'PERSON_BUSINESS_VALUE') {
          defaultValue = "B";
        } else if (metadata.attrib_name === 'FAIR_MARKET_VALUE' ||
                   metadata.attrib_name === 'ADJUST_BASIS') {
          defaultValue = 0;
        }

        transformedData[index] = {
          ...metadata,
          trans_details_key: null,
          occurrence: null,
          VALUE: defaultValue
        };
        index++;
      }
    }

    this.selectedTabEData = transformedData;
  }

  clearTabData(tabIndex: number) {
    this.editFlag = false;
    
    if (tabIndex === 0) {
      this.collapsed1 = true;
      this.collapsed2 = true;
      this.collapsed3 = true;
      this.collapsed4 = true;
      this.collapsed5 = true;
    }
    
    switch(tabIndex) {
      case 0:
        this.selectedTab5471Data = [];
        break;
      case 1:
        this.selectedTabCData = [];
        break;
      case 2:
        this.selectedTabDData = [];
        break;
      case 3:
        this.selectedTabEData = [];
        break;
      case 4:
        this.selectedTabBData = [];
        break;
      case 5:
        if (!this.selectedTabAData || this.selectedTabAData.length === 0 || !this.selectedTabAData[0]?.attrib_name) {
          this.selectedTabAData = [];
        }
        break;
    }
  }


  onSectionAInputChange(index: number, event: any) {
    const value = (event.target as HTMLInputElement).value;

    if (!this.selectedTabAData || this.selectedTabAData.length === 0) {
      this.initializeSectionAData();
    }
    if (!this.selectedTabAData[index]) {
      return;
    }

    this.selectedTabAData[index].VALUE = value;
    
    if (index === 0) {
      // Section A date is required, but has no range condition
      if (value) {
        this.clearValidationError('sectionA_date');
      }
      this.A_date_flag = false;
    }
  }

  onSectionBInputChange(index: number, event: any) {
    const rawValue = (event.target as HTMLInputElement | HTMLSelectElement).value;

    if (!this.selectedTabBData || this.selectedTabBData.length === 0) {
      this.initializeSectionBData();
    }
    if (!this.selectedTabBData[index]) {
      return;
    }
    
    let processedValue = rawValue;
    
    if (index === 6) {
      if (this.selectedTabBData[2]?.VALUE?.COUNTRY_CODE === 'US') {
        if (rawValue && typeof rawValue === 'string') {
          const stateObj = this.states.find(s => s.code === rawValue);
          processedValue = stateObj || rawValue;
        }
      } else {
        processedValue = rawValue;
      }
    }
    
    this.selectedTabBData[index].VALUE = processedValue;
    
    this.clearValidationError(`sectionB_${index}`);
  }

  onSectionBCountryChange(event: any) {
    const countryCode = (event.target as HTMLSelectElement).value;
    const country = this.countries.find(c => c.COUNTRY_CODE === countryCode);

    if (!this.selectedTabBData || this.selectedTabBData.length === 0) {
      this.initializeSectionBData();
    }
    if (!this.selectedTabBData || this.selectedTabBData.length < 11 || !this.selectedTabBData[2]) {
      return;
    }
    
    this.selectedTabBData[2].VALUE = country;
    
    this.changeCountryForSectionB(countryCode);
    
    this.clearValidationError('sectionB_country');
  }

  private changeCountryForSectionB(countryCode: string) {
    if (!this.selectedTabBData || this.selectedTabBData.length < 11) {
      return;
    }
    
    if (this.selectedTabBData[6]) {
      this.selectedTabBData[6].VALUE = null;
    }
    if (this.selectedTabBData[7]) {
      this.selectedTabBData[7].VALUE = null;
    }
    
    if (this.selectedTabBData[3]) {
      this.selectedTabBData[3].attrib_name = countryCode === 'US' ? 
        '5471_O_US_PER_OFF_DIR_US_ADDR_1' : '5471_O_US_PER_OFF_DIR_F_ADDR_1';
      
      const temp_obj = this.findTabBAttributeByName(this.selectedTabBData[3].attrib_name);
      if (temp_obj) {
        this.selectedTabBData[3].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabBData[3].attrib_description = temp_obj.attrib_description;
      }
    }
    
    if (this.selectedTabBData[4]) {
      this.selectedTabBData[4].attrib_name = countryCode === 'US' ? 
        '5471_O_US_PER_OFF_DIR_US_ADDR_2' : '5471_O_US_PER_OFF_DIR_F_ADDR_2';
      
      const temp_obj = this.findTabBAttributeByName(this.selectedTabBData[4].attrib_name);
      if (temp_obj) {
        this.selectedTabBData[4].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabBData[4].attrib_description = temp_obj.attrib_description;
      }
    }
    
    if (this.selectedTabBData[5]) {
      this.selectedTabBData[5].attrib_name = countryCode === 'US' ? 
        '5471_O_US_PER_OFF_DIR_US_CITY' : '5471_O_US_PER_OFF_DIR_F_CITY';
      
      const temp_obj = this.findTabBAttributeByName(this.selectedTabBData[5].attrib_name);
      if (temp_obj) {
        this.selectedTabBData[5].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabBData[5].attrib_description = temp_obj.attrib_description;
      }
    }
    
    if (this.selectedTabBData[6]) {
      this.selectedTabBData[6].attrib_name = countryCode === 'US' ? 
        '5471_O_US_PER_OFF_DIR_US_STATE' : '5471_O_US_PER_OFF_DIR_F_STATE';
      
      const temp_obj = this.findTabBAttributeByName(this.selectedTabBData[6].attrib_name);
      if (temp_obj) {
        this.selectedTabBData[6].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabBData[6].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update Zip (lines 2582-2592)
    if (this.selectedTabBData[7]) {
      this.selectedTabBData[7].attrib_name = countryCode === 'US' ? 
        '5471_O_US_PER_OFF_DIR_US_ZIP' : '5471_O_US_PER_OFF_DIR_F_ZIP';
      
      const temp_obj = this.findTabBAttributeByName(this.selectedTabBData[7].attrib_name);
      if (temp_obj) {
        this.selectedTabBData[7].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabBData[7].attrib_description = temp_obj.attrib_description;
      }
    }
  }

  // Helper method to find attribute metadata by name (replicates AngularJS _.find)
  private findTabBAttributeByName(attribName: string): any {
    const found = this.tabBAttribDetails.find(item => item.attrib_name === attribName);
    
    return found || null;
  }

  // Helper method to find Section C attribute metadata by name (replicates AngularJS _.find)
  private findTabCAttributeByName(attribName: string): any {
    const found = this.tabCAttribDetails.find(item => item.attrib_name === attribName);
    
    return found || null;
  }


  onSectionCInputChange(index: number, event: any) {
    const rawValue = (event.target as HTMLInputElement | HTMLSelectElement).value;

    if (!this.selectedTabCData || this.selectedTabCData.length === 0) {
      this.initializeSectionCData();
    }
    if (!this.selectedTabCData[index]) {
      return;
    }
    
    // Handle special field transformations
    let processedValue = rawValue;
    
    // Special handling for state field (index 15)
    if (index === 15 && this.selectedTabCData[11]?.VALUE?.COUNTRY_CODE === 'US') {
      // For US states, convert string code to state object
      if (rawValue && typeof rawValue === 'string') {
        const stateObj = this.states.find(s => s.code === rawValue);
        processedValue = stateObj || rawValue;
      }
    }
    
    // Only update VALUE, preserve all metadata
    if (this.selectedTabCData[index]) {
      // Handle shareholder selection specially
      if (index === 0) {
        // For shareholder dropdown, find the object by LEID
        const selectedItem = this.filingGroup.find(item => item.LEID === rawValue);
        this.selectedTabCData[index].VALUE = selectedItem || null;
      } else {
        this.selectedTabCData[index].VALUE = processedValue;
      }
      
      // Special handling for Person/Business toggle (index 8)
      if (index === 8 && rawValue === 'P') {
        // When switching to Person, clear Name Line 2 (index 10) if it has a value
        if (this.selectedTabCData[10] && this.selectedTabCData[10].VALUE) {
          this.selectedTabCData[10].VALUE = null;
        }
      }
      
      // CRITICAL: DO NOT modify occurrence values during user input
      // Occurrence values should be preserved from edit data to maintain record integrity
      // The occurrence value identifies the specific record instance in the backend
    }
    
    // Clear validation errors when user starts typing
    switch(index) {
      case 0:
        this.clearValidationError('sectionC_shareholder');
        break;
      case 2:
        this.clearValidationError('sectionC_date');
        if (rawValue && !this.isDateInRange(rawValue)) {
          this.setValidationError('sectionC_date', `Date must be between ${this.formatDate(this.rowData.TAX_YEAR_BEGIN)} and ${this.formatDate(this.rowData.TAX_YEAR_END)}`);
          this.C_date_flag = true;
        } else {
          this.C_date_flag = false;
        }
        break;
      case 9:
        this.clearValidationError('sectionC_name');
        break;
      case 11:
        this.clearValidationError('sectionC_country');
        break;
      case 12:
        this.clearValidationError('sectionC_address1');
        break;
      case 14:
        this.clearValidationError('sectionC_city');
        break;
      case 15:
        this.clearValidationError('sectionC_state');
        break;
      case 16:
        this.clearValidationError('sectionC_zip');
        break;
    }
  }

  onSectionCCountryChange(event: any) {
    const countryCode = (event.target as HTMLSelectElement).value;
    const country = this.countries.find(c => c.COUNTRY_CODE === countryCode);

    if (!this.selectedTabCData || this.selectedTabCData.length === 0) {
      this.initializeSectionCData();
    }
    if (!this.selectedTabCData || !this.selectedTabCData[11]) {
      return;
    }
    this.selectedTabCData[11].VALUE = country;
    
    // EXACT AngularJS compliance: Call changeCountry logic for Section C
    this.changeCountryForSectionC(countryCode);
    
    this.clearValidationError('sectionC_country');
  }

  // EXACT AngularJS replication: vm.changeCountry() for Section C
  private changeCountryForSectionC(countryCode: string) {
    
    // CRITICAL SAFETY CHECK: Ensure selectedTabCData is properly initialized
    if (!this.selectedTabCData || this.selectedTabCData.length < 17) {
      return;
    }
    
    // EXACT AngularJS logic: Clear state and zip values (lines 2320-2321)
    if (this.selectedTabCData[15]) {
      this.selectedTabCData[15].VALUE = null;
    }
    if (this.selectedTabCData[16]) {
      this.selectedTabCData[16].VALUE = null;
    }
    
    // EXACT AngularJS logic: Update Address Line 1 (lines 2323-2333)
    if (this.selectedTabCData[12]) {
      this.selectedTabCData[12].attrib_name = countryCode === 'US' ? 
        'ADDRESS_LINE_1' : '5471_O_STOCK_ACQ_F_ADDR_1';
      
      // Find matching metadata from tabCAttribDetails (API data)
      const temp_obj = this.findTabCAttributeByName(this.selectedTabCData[12].attrib_name);
      if (temp_obj) {
        this.selectedTabCData[12].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabCData[12].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update Address Line 2 (lines 2336-2346)
    if (this.selectedTabCData[13]) {
      this.selectedTabCData[13].attrib_name = countryCode === 'US' ? 
        'ADDRESS_LINE_2' : '5471_O_STOCK_ACQ_F_ADDR_2';
      
      const temp_obj = this.findTabCAttributeByName(this.selectedTabCData[13].attrib_name);
      if (temp_obj) {
        this.selectedTabCData[13].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabCData[13].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update City (lines 2349-2359)
    if (this.selectedTabCData[14]) {
      this.selectedTabCData[14].attrib_name = countryCode === 'US' ? 
        'CITY' : '5471_O_STOCK_ACQ_F_CITY';
      
      const temp_obj = this.findTabCAttributeByName(this.selectedTabCData[14].attrib_name);
      if (temp_obj) {
        this.selectedTabCData[14].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabCData[14].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update State (lines 2362-2372) - CRITICAL FIX!
    if (this.selectedTabCData[15]) {
      this.selectedTabCData[15].attrib_name = countryCode === 'US' ? 
        'STATE' : '5471_O_STOCK_ACQ_F_STATE';
      
      const temp_obj = this.findTabCAttributeByName(this.selectedTabCData[15].attrib_name);
      if (temp_obj) {
        this.selectedTabCData[15].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabCData[15].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update Zip (lines 2375-2385)
    if (this.selectedTabCData[16]) {
      this.selectedTabCData[16].attrib_name = countryCode === 'US' ? 
        'ZIP_POSTAL_CODE' : '5471_O_STOCK_ACQ_F_ZIP';
      
      const temp_obj = this.findTabCAttributeByName(this.selectedTabCData[16].attrib_name);
      if (temp_obj) {
        this.selectedTabCData[16].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabCData[16].attrib_description = temp_obj.attrib_description;
      }
    }
    
  }

  // EXACT AngularJS replication: Helper method to find Section D attribute metadata by name
  private findTabDAttributeByName(attribName: string): any {
    const found = this.tabDAttribDetails.find(item => item.attrib_name === attribName);
    
    return found;
  }

  onSectionDInputChange(index: number, event: any) {
    const rawValue = (event.target as HTMLInputElement | HTMLSelectElement).value;

    if (!this.selectedTabDData || this.selectedTabDData.length === 0) {
      this.initializeSectionDData();
    }
    if (!this.selectedTabDData[index]) {
      return;
    }
    
    // Handle special field transformations
    let processedValue = rawValue;
    
    // Special handling for state field (index 15)
    if (index === 15) {
      // Check country field (index 11) to determine if US
      if (this.selectedTabDData[11]?.VALUE?.COUNTRY_CODE === 'US') {
        // For US states, convert string code to state object
        if (rawValue && typeof rawValue === 'string') {
          const stateObj = this.states.find(s => s.code === rawValue);
          processedValue = stateObj || rawValue;
        }
      } else {
        // For Foreign states, store as string directly
        processedValue = rawValue;
      }
    }
    
    // Only update VALUE, preserve all metadata
    if (this.selectedTabDData[index]) {
      // Handle shareholder selection specially
      if (index === 0) {
        // For shareholder dropdown, find the object by LEID
        const selectedItem = this.filingGroup.find(item => item.LEID === rawValue);
        this.selectedTabDData[index].VALUE = selectedItem || null;
      } else {
        this.selectedTabDData[index].VALUE = processedValue;
      }
      
      // Special handling for Person/Business toggle (index 8)
      if (index === 8 && rawValue === 'P') {
        // When switching to Person, clear Name Line 2 (index 10) if it has a value
        if (this.selectedTabDData[10] && this.selectedTabDData[10].VALUE) {
          this.selectedTabDData[10].VALUE = null;
        }
      } 
    }
    
    // Clear validation errors when user starts typing
    switch(index) {
      case 0:
        this.clearValidationError('sectionD_shareholder');
        break;
      case 2:
        this.clearValidationError('sectionD_date');
        if (rawValue && !this.isDateInRange(rawValue)) {
          this.setValidationError('sectionD_date', `Date must be between ${this.formatDate(this.rowData.TAX_YEAR_BEGIN)} and ${this.formatDate(this.rowData.TAX_YEAR_END)}`);
          this.D_date_flag = true;
        } else {
          this.D_date_flag = false;
        }
        break;
      case 9:
        this.clearValidationError('sectionD_name');
        break;
      case 11:
        this.clearValidationError('sectionD_country');
        break;
      case 12:
        this.clearValidationError('sectionD_address1');
        break;
      case 14:
        this.clearValidationError('sectionD_city');
        break;
      case 15:
        this.clearValidationError('sectionD_state');
        break;
      case 16:
        this.clearValidationError('sectionD_zip');
        break;
    }
  }

  onSectionDCountryChange(event: any) {
    const countryCode = (event.target as HTMLSelectElement).value;
    const country = this.countries.find(c => c.COUNTRY_CODE === countryCode);

    if (!this.selectedTabDData || this.selectedTabDData.length === 0) {
      this.initializeSectionDData();
    }
    if (!this.selectedTabDData || this.selectedTabDData.length < 17 || !this.selectedTabDData[11]) {
      return;
    }
    
    this.selectedTabDData[11].VALUE = country;
    
    // EXACT AngularJS compliance: Call changeCountry logic for Section D
    this.changeCountryForSectionD(countryCode);
    
    this.clearValidationError('sectionD_country');
  }

  private changeCountryForSectionD(countryCode: string) {
    if (!this.selectedTabDData || this.selectedTabDData.length < 17) {
      return;
    }
    
    // EXACT AngularJS logic: Clear state and zip values (lines 2390-2391)
    if (this.selectedTabDData[15]) {
      this.selectedTabDData[15].VALUE = null;
    }
    if (this.selectedTabDData[16]) {
      this.selectedTabDData[16].VALUE = null;
    }
    
    // EXACT AngularJS logic: Update Address Line 1 (lines 2393-2403)
    if (this.selectedTabDData[12]) {
      this.selectedTabDData[12].attrib_name = countryCode === 'US' ? 
        'ADDRESS_LINE_1' : '5471_O_STOCK_DIS_F_ADDR_1';
      
      // Find matching metadata from tabDAttribDetails (API data)
      const temp_obj = this.findTabDAttributeByName(this.selectedTabDData[12].attrib_name);
      if (temp_obj) {
        this.selectedTabDData[12].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabDData[12].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update Address Line 2 (lines 2406-2416)
    if (this.selectedTabDData[13]) {
      this.selectedTabDData[13].attrib_name = countryCode === 'US' ? 
        'ADDRESS_LINE_2' : '5471_O_STOCK_DIS_F_ADDR_2';
      
      const temp_obj = this.findTabDAttributeByName(this.selectedTabDData[13].attrib_name);
      if (temp_obj) {
        this.selectedTabDData[13].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabDData[13].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update City (lines 2419-2429)
    if (this.selectedTabDData[14]) {
      this.selectedTabDData[14].attrib_name = countryCode === 'US' ? 
        'CITY' : '5471_O_STOCK_DIS_F_CITY';
      
      const temp_obj = this.findTabDAttributeByName(this.selectedTabDData[14].attrib_name);
      if (temp_obj) {
        this.selectedTabDData[14].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabDData[14].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update State (lines 2432-2442)
    if (this.selectedTabDData[15]) {
      this.selectedTabDData[15].attrib_name = countryCode === 'US' ? 
        'STATE' : '5471_O_STOCK_DIS_F_STATE';
      
      const temp_obj = this.findTabDAttributeByName(this.selectedTabDData[15].attrib_name);
      if (temp_obj) {
        this.selectedTabDData[15].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabDData[15].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update Zip (lines 2445-2455)
    if (this.selectedTabDData[16]) {
      this.selectedTabDData[16].attrib_name = countryCode === 'US' ? 
        'ZIP_POSTAL_CODE' : '5471_O_STOCK_DIS_F_ZIP';
      
      const temp_obj = this.findTabDAttributeByName(this.selectedTabDData[16].attrib_name);
      if (temp_obj) {
        this.selectedTabDData[16].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabDData[16].attrib_description = temp_obj.attrib_description;
      }
    }
    
  }

  onSectionEInputChange(index: number, event: any) {
    const rawValue = (event.target as HTMLInputElement | HTMLSelectElement).value;

    if (!this.selectedTabEData || this.selectedTabEData.length === 0) {
      this.initializeSectionEData();
    }
    if (!this.selectedTabEData[index]) {
      return;
    }
    
    // Handle special field transformations
    let processedValue = rawValue;
    
    // Special handling for state field (index 8)
    if (index === 8) {
      // Check country field (index 4) to determine if US
      if (this.selectedTabEData[4]?.VALUE?.COUNTRY_CODE === 'US') {
        // For US states, convert string code to state object
        if (rawValue && typeof rawValue === 'string') {
          const stateObj = this.states.find(s => s.code === rawValue);
          processedValue = stateObj || rawValue;
        }
      } else {
        // For Foreign states, store as string directly
        processedValue = rawValue;
      }
    }
    
    // Only update VALUE, preserve all metadata
    if (this.selectedTabEData[index]) {
      this.selectedTabEData[index].VALUE = processedValue;
      
      // Special handling for Person/Business toggle (index 1)
      if (index === 1 && rawValue === 'P') {
        // When switching to Person, clear Name Line 2 (index 3) if it has a value
        if (this.selectedTabEData[3] && this.selectedTabEData[3].VALUE) {
          this.selectedTabEData[3].VALUE = null;
        }
      }
    }
    
    // Clear validation errors when user starts typing
    switch(index) {
      case 2:
        this.clearValidationError('sectionE_name');
        break;
      case 4:
        this.clearValidationError('sectionE_country');
        break;
      case 5:
        this.clearValidationError('sectionE_address1');
        break;
      case 7:
        this.clearValidationError('sectionE_city');
        break;
      case 8:
        this.clearValidationError('sectionE_state');
        break;
      case 9:
        this.clearValidationError('sectionE_zip');
        break;
      case 11:
        this.clearValidationError('sectionE_date');
        if (rawValue && !this.isDateInRange(rawValue)) {
          this.setValidationError('sectionE_date', `Date must be between ${this.formatDate(this.rowData.TAX_YEAR_BEGIN)} and ${this.formatDate(this.rowData.TAX_YEAR_END)}`);
          this.E_date_flag = true;
        } else {
          this.E_date_flag = false;
        }
        break;
    }
  }

  onSectionECountryChange(event: any) {
    const countryCode = (event.target as HTMLSelectElement).value;
    const country = this.countries.find(c => c.COUNTRY_CODE === countryCode);

    if (!this.selectedTabEData || this.selectedTabEData.length === 0) {
      this.initializeSectionEData();
    }
    if (!this.selectedTabEData || this.selectedTabEData.length < 16 || !this.selectedTabEData[4]) {
      return;
    }
    
    this.selectedTabEData[4].VALUE = country;
    
    // EXACT AngularJS compliance: Call changeCountry logic for Section E
    this.changeCountryForSectionE(countryCode);
    
    this.clearValidationError('sectionE_country');
  }

  private changeCountryForSectionE(countryCode: string) {
    if (!this.selectedTabEData || this.selectedTabEData.length < 16) {
      return;
    }
    
    // EXACT AngularJS logic: Clear state and zip values
    if (this.selectedTabEData[8]) {
      this.selectedTabEData[8].VALUE = null;
    }
    if (this.selectedTabEData[9]) {
      this.selectedTabEData[9].VALUE = null;
    }
    
    // Clear Adjusted basis when switching to foreign country (Issue #3)
    if (countryCode !== 'US' && this.selectedTabEData[14]) {
      this.selectedTabEData[14].VALUE = null;
    }
    
    // EXACT AngularJS logic: Update Address Line 1
    if (this.selectedTabEData[5]) {
      this.selectedTabEData[5].attrib_name = countryCode === 'US' ? 
        'ADDRESS_LINE_1' : '5471_O_ORG_REORG_F_ADDR_1';
      
      // Find matching metadata from tabEAttribDetails (API data)
      const temp_obj = this.findTabEAttributeByName(this.selectedTabEData[5].attrib_name);
      if (temp_obj) {
        this.selectedTabEData[5].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabEData[5].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update Address Line 2
    if (this.selectedTabEData[6]) {
      this.selectedTabEData[6].attrib_name = countryCode === 'US' ? 
        'ADDRESS_LINE_2' : '5471_O_ORG_REORG_F_ADDR_2';
      
      const temp_obj = this.findTabEAttributeByName(this.selectedTabEData[6].attrib_name);
      if (temp_obj) {
        this.selectedTabEData[6].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabEData[6].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update City
    if (this.selectedTabEData[7]) {
      this.selectedTabEData[7].attrib_name = countryCode === 'US' ? 
        'CITY' : '5471_O_ORG_REORG_F_CITY';
      
      const temp_obj = this.findTabEAttributeByName(this.selectedTabEData[7].attrib_name);
      if (temp_obj) {
        this.selectedTabEData[7].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabEData[7].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update State
    if (this.selectedTabEData[8]) {
      this.selectedTabEData[8].attrib_name = countryCode === 'US' ? 
        'STATE' : '5471_O_ORG_REORG_F_STATE';
      
      const temp_obj = this.findTabEAttributeByName(this.selectedTabEData[8].attrib_name);
      if (temp_obj) {
        this.selectedTabEData[8].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabEData[8].attrib_description = temp_obj.attrib_description;
      }
    }
    
    // EXACT AngularJS logic: Update Zip
    if (this.selectedTabEData[9]) {
      this.selectedTabEData[9].attrib_name = countryCode === 'US' ? 
        'ZIP_POSTAL_CODE' : '5471_O_ORG_REORG_F_ZIP';
      
      const temp_obj = this.findTabEAttributeByName(this.selectedTabEData[9].attrib_name);
      if (temp_obj) {
        this.selectedTabEData[9].line_attrib_key = temp_obj.line_attrib_key;
        this.selectedTabEData[9].attrib_description = temp_obj.attrib_description;
      }
    }
    
  }

  // EXACT AngularJS replication: Helper method to find Section E attribute metadata by name
  private findTabEAttributeByName(attribName: string): any {

    const found = this.tabEAttribDetails.find(item => item.attrib_name === attribName);
    
    return found;
  }

  // Edit and delete schedule methods

  save() {
    // Set submitted flag for validation display
    this.submitted = true;
    
    // Tab-specific save logic matching original AngularJS
    switch(this.activeTab) {
      case 0: 
        this.save5471Tab();
        break;
      case 1: 
        this.tabC_flag = true;
        this.tabD_flag = false;
        this.tabE_flag = false;
        this.tabB_flag = false;
        this.tabA_flag = false;
        this.stockAcquisition();
        break;
      case 2: 
        this.tabC_flag = false;
        this.tabD_flag = true;
        this.tabE_flag = false;
        this.tabB_flag = false;
        this.tabA_flag = false;
        this.stockDisposition();
        break;
      case 3: 
        this.tabC_flag = false;
        this.tabD_flag = false;
        this.tabE_flag = true;
        this.tabB_flag = false;
        this.tabA_flag = false;
        this.reorganizationInfo();
        break;
      case 4: 
        this.tabC_flag = false;
        this.tabD_flag = false;
        this.tabE_flag = false;
        this.tabB_flag = true;
        this.tabA_flag = false;
        this.sectionBInfo();
        break;
      case 5: 
        this.tabC_flag = false;
        this.tabD_flag = false;
        this.tabE_flag = false;
        this.tabB_flag = false;
        this.tabA_flag = true;
        this.sectionAInfo();
        break;
      default:
        console.warn('Unknown tab for save:', this.activeTab);
    }
  }

  // Tab-specific save methods matching original AngularJS logic
  save5471Tab() {
    // Validate main 5471 form first
    if (!this.validateMain5471()) {
      return; // Exit if validation fails
    }
    
    this.isSaveClicked = true;
    this.crudLoading = true;
    this.startApiCall(); // Track save API call

    // Prepare save data for main 5471 tab
    const saveData = this.prepareSaveDataFor5471();

    this.fir5471ScheduleOService.saveScheduleO(
      this.GENERAL_CONFIG.base_url,
      saveData.scheduleSettings,
      saveData.scheduleDetails,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (response: any) => {
        this.handleSaveResponse(response, 'Main 5471 data has been successfully saved');
      },
      (error: any) => {
        this.handleSaveError(error);
      }
    );
  }

  stockAcquisition() {
    // Validation for Section C (Stock Acquisition)
    if (!this.validateSectionC()) {
      this.crudLoading = false;
      return;
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.startApiCall(); // Track save API call

    const saveData = this.prepareSaveDataForSectionC();
    
    this.fir5471ScheduleOService.saveScheduleO(
      this.GENERAL_CONFIG.base_url,
      saveData.scheduleSettings,
      saveData.scheduleDetails,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (response: any) => {
        this.handleSaveResponse(response, 'Stock acquisition data has been successfully saved');
      },
      (error: any) => {
        this.handleSaveError(error);
      }
    );
  }

  stockDisposition() {
    // Validation for Section D (Stock Disposition)
    if (!this.validateSectionD()) {
      this.crudLoading = false;
      return;
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.startApiCall(); // Track save API call

    const saveData = this.prepareSaveDataForSectionD();
    
    this.fir5471ScheduleOService.saveScheduleO(
      this.GENERAL_CONFIG.base_url,
      saveData.scheduleSettings,
      saveData.scheduleDetails,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (response: any) => {
        this.handleSaveResponse(response, 'Stock disposition data has been successfully saved');
      },
      (error: any) => {
        this.handleSaveError(error);
      }
    );
  }

  reorganizationInfo() {
    // Validation for Section E (Reorganization)
    if (!this.validateSectionE()) {
      this.crudLoading = false;
      return;
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.startApiCall(); // Track save API call

    const saveData = this.prepareSaveDataForSectionE();
    this.saveSection(saveData, 'Reorganization information has been successfully saved');
  }

  sectionBInfo() {
    // Validation for Section B
    if (!this.validateSectionB()) {
      this.crudLoading = false;
      return;
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.startApiCall(); // Track save API call

    const saveData = this.prepareSaveDataForSectionB();
    this.saveSection(saveData, 'Section B information has been successfully saved');
  }


  // Common save method for sections
  private saveSection(saveData: any, successMessage: string) {
    const scheduleSettings = saveData.scheduleSettings || [];
    const scheduleDetails = saveData.scheduleDetails || {};
    
    this.fir5471ScheduleOService.saveScheduleO(
      this.GENERAL_CONFIG.base_url,
      scheduleSettings,
      scheduleDetails,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (response: any) => {
        this.handleSaveResponse(response, successMessage);
      },
      (error: any) => {
        this.handleSaveError(error);
      }
    );
  }

  // Common response handlers
  private handleSaveResponse(response: any, successMessage: string) {
    this.isSaveClicked = false;
    this.crudLoading = false;
    this.finishApiCall(); // Finish the save API call

    if (response.errorMessage && response.errorMessage !== 'null') {
      this.gtwSnackbarService.openSnackBar(response.errorMessage, 'gtw-snackbar--red');
    } else {
      this.gtwSnackbarService.openSnackBar(successMessage, 'gtw-snackbar--green');
      this.editFlag = false;
      
      // EXACT AngularJS behavior: reload data and switch to tab 0
      this.refreshDataAfterSave(); // Safe data refresh without modal-closing side effects
      // Note: activeTab = 0 is now handled by loadScheduleODetails() to match AngularJS timing
      
      // NOTE: AngularJS main save functions do NOT emit gridUpdate events
      // Grid refresh events are only emitted in cancel() and service-level saves
    }
  }

  private handleSaveError(error: any) {
    this.isSaveClicked = false;
    this.crudLoading = false;
    this.finishApiCall(); // Finish the save API call even on error
    this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
    console.error('Save error:', error);
  }

  // Safe data refresh after save - no modal closing side effects
  private refreshDataAfterSave() {
    
    // Reset edit flag similar to AngularJS
    this.editFlag = false;
    
    // Clear all data arrays like AngularJS does
    this.sectionAData = [];
    this.sectionBData = [];
    this.sectionCData = [];
    this.sectionDData = [];
    this.sectionEData = [];
    this.tab5471Data = [];
    
    // Clear selected data arrays
    this.selectedTabAData = [];
    this.selectedTabBData = [];
    this.selectedTabCData = [];
    this.selectedTabDData = [];
    this.selectedTabEData = [];
    this.selectedTab5471Data = [];
    
    
    // CRITICAL FIX: Use the exact same method as initial load, just like AngularJS does
    // AngularJS calls loadF5471ScheduleODetails() for both initial load and refresh
    this.loadScheduleODetails(true); // Pass true to indicate this is a refresh after save
    
  }

  // Validation methods for each section
  private validateSectionA(): boolean {
    this.tabA_flag = true;
    let isValid = true;
    
    // Section A date field is required, but has no range condition
    const dateValue = this.selectedTabAData && this.selectedTabAData[0]?.VALUE;
    if (!dateValue) {
      this.setValidationError('sectionA_date', 'Date is required');
      this.A_date_flag = false;
      isValid = false;
    } else {
      this.clearValidationError('sectionA_date');
      this.A_date_flag = false;
    }
    
    if (!isValid) {
      this.gtwSnackbarService.openSnackBar('Please fill out required fields for Section A.', 'gtw-snackbar--red');
    }
    
    return isValid;
  }
  
  private formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = this.toLocalDate(dateString);
    return date ? date.toLocaleDateString('en-US') : '';
  }

  private validateSectionB(): boolean {
    this.tabB_flag = true;
    let isValid = true;
    
    // EXACT AngularJS compliance: If selectedTabBData is empty (no LINE6_ATTRIB), validation fails
    // This matches AngularJS behavior where empty vm.selectedTabBData prevents saving
    if (!this.selectedTabBData || this.selectedTabBData.length === 0) {
      // Don't show validation error unless user actually tries to save
      // This matches AngularJS behavior: form visible, but save fails silently without metadata
      isValid = false;
    } else {
      // First Name (required)
      const firstName = this.selectedTabBData[0]?.VALUE;
      if (!firstName) {
        this.setValidationError('sectionB_firstName', 'Name is required');
        isValid = false;
      } else if (!this.validateAlphaNumeric(firstName)) {
        this.setValidationError('sectionB_firstName', 'Name contains invalid characters');
        isValid = false;
      } else {
        this.clearValidationError('sectionB_firstName');
      }
      
      // Country (required)
      const country = this.selectedTabBData[2]?.VALUE;
      if (!country) {
        this.setValidationError('sectionB_country', 'Country is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionB_country');
      }
      
      // Address Line 1 (required)
      const address1 = this.selectedTabBData[3]?.VALUE;
      if (!address1) {
        this.setValidationError('sectionB_address1', 'Address is required');
        isValid = false;
      } else if (!this.validateAlphaNumeric(address1)) {
        this.setValidationError('sectionB_address1', 'Address contains invalid characters');
        isValid = false;
      } else {
        this.clearValidationError('sectionB_address1');
      }
      
      // US-specific validation
      if (country?.COUNTRY_CODE === 'US') {
        // City (required for US)
        const city = this.selectedTabBData[5]?.VALUE;
        if (!city) {
          this.setValidationError('sectionB_city', 'City is required');
          isValid = false;
        } else if (!this.validateAlphaNumeric(city)) {
          this.setValidationError('sectionB_city', 'City contains invalid characters');
          isValid = false;
        } else {
          this.clearValidationError('sectionB_city');
        }
        
        // State (required for US)
        const state = this.selectedTabBData[6]?.VALUE;
        if (!state) {
          this.setValidationError('sectionB_state', 'State is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionB_state');
        }
        
        // Zip (required for US)
        const zip = this.selectedTabBData[7]?.VALUE;
        if (!zip) {
          this.setValidationError('sectionB_zip', 'Zip is required');
          isValid = false;
        } else if (!this.validateZipCode(zip, 'US')) {
          this.setValidationError('sectionB_zip', 'Zip code must contain only numbers');
          isValid = false;
        } else {
          this.clearValidationError('sectionB_zip');
        }
      } else {
        // Clear US-specific validations for non-US countries
        this.clearValidationError('sectionB_city');
        this.clearValidationError('sectionB_state');
        this.clearValidationError('sectionB_zip');
      }
    }
    
    if (!isValid) {
      this.gtwSnackbarService.openSnackBar('Please fill out required fields for Section B.', 'gtw-snackbar--red');
    }
    
    return isValid;
  }

  private validateSectionC(): boolean {
    this.tabC_flag = true;
    let isValid = true;
    
    if (!this.selectedTabCData || this.selectedTabCData.length === 0) {
      this.setValidationError('sectionC_general', 'Stock Acquisition data is required');
      isValid = false;
    } else {
      // Shareholder (required)
      const shareholder = this.selectedTabCData[0]?.VALUE;
      if (!shareholder || !shareholder.LEID) {
        this.setValidationError('sectionC_shareholder', 'Shareholder is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionC_shareholder');
      }
      
      // Date (required)
      const dateValue = this.selectedTabCData[2]?.VALUE;
      if (!dateValue) {
        this.setValidationError('sectionC_date', 'Date is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionC_date');
        // Validate date range
        if (!this.isDateInRange(dateValue)) {
          this.setValidationError('sectionC_date', `Date must be between ${this.formatDate(this.rowData.TAX_YEAR_BEGIN)} and ${this.formatDate(this.rowData.TAX_YEAR_END)}`);
          this.C_date_flag = true;
          isValid = false;
        } else {
          this.C_date_flag = false;
        }
      }
      
      // Name Line 1 (required)
      const name = this.selectedTabCData[9]?.VALUE;
      if (!name) {
        this.setValidationError('sectionC_name', 'Name is required');
        isValid = false;
      } else if (!this.validateAlphaNumeric(name)) {
        this.setValidationError('sectionC_name', 'Name contains invalid characters');
        isValid = false;
      } else {
        this.clearValidationError('sectionC_name');
      }
      
      // Country (required)
      const country = this.selectedTabCData[11]?.VALUE;
      if (!country) {
        this.setValidationError('sectionC_country', 'Country is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionC_country');
      }
      
      // Address Line 1 (required)
      const address1 = this.selectedTabCData[12]?.VALUE;
      if (!address1) {
        this.setValidationError('sectionC_address1', 'Address is required');
        isValid = false;
      } else if (!this.validateAlphaNumeric(address1)) {
        this.setValidationError('sectionC_address1', 'Address contains invalid characters');
        isValid = false;
      } else {
        this.clearValidationError('sectionC_address1');
      }
      
      // US-specific validation
      if (country?.COUNTRY_CODE === 'US') {
        // City (required for US)
        const city = this.selectedTabCData[14]?.VALUE;
        if (!city) {
          this.setValidationError('sectionC_city', 'City is required');
          isValid = false;
        } else if (!this.validateAlphaNumeric(city)) {
          this.setValidationError('sectionC_city', 'City contains invalid characters');
          isValid = false;
        } else {
          this.clearValidationError('sectionC_city');
        }
        
        // State (required for US)
        const state = this.selectedTabCData[15]?.VALUE;
        if (!state) {
          this.setValidationError('sectionC_state', 'State is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionC_state');
        }
        
        // Zip (required for US)
        const zip = this.selectedTabCData[16]?.VALUE;
        if (!zip) {
          this.setValidationError('sectionC_zip', 'Zip is required');
          isValid = false;
        } else if (!this.validateZipCode(zip, 'US')) {
          this.setValidationError('sectionC_zip', 'Zip code must contain only numbers');
          isValid = false;
        } else {
          this.clearValidationError('sectionC_zip');
        }
      } else {
        // Clear US-specific validations for non-US countries
        this.clearValidationError('sectionC_city');
        this.clearValidationError('sectionC_state');
        this.clearValidationError('sectionC_zip');
      }
    }
    
    if (!isValid) {
      this.gtwSnackbarService.openSnackBar('Please fill out required fields for Stock Acquisition.', 'gtw-snackbar--red');
    }
    
    return isValid;
  }

  private validateSectionD(): boolean {
    this.tabD_flag = true;
    let isValid = true;
    
    if (!this.selectedTabDData || this.selectedTabDData.length === 0) {
      this.setValidationError('sectionD_general', 'Stock Disposition data is required');
      isValid = false;
    } else {
      // Shareholder (required) - AngularJS: angular.isDefined(vm.selectedTabDData[0].VALUE.LEGAL_ENTITY_ID)
      const shareholder = this.selectedTabDData[0]?.VALUE;
      if (!shareholder || !shareholder.LEGAL_ENTITY_ID) {
        this.setValidationError('sectionD_shareholder', 'Shareholder is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionD_shareholder');
      }
      
      // Date range check (NOT required, only range) - AngularJS: vm.D_date_flag
      const dateValue = this.selectedTabDData[2]?.VALUE;
      if (dateValue) {
        if (!this.isDateInRange(dateValue)) {
          this.setValidationError('sectionD_date', `Date must be between ${this.formatDate(this.rowData.TAX_YEAR_BEGIN)} and ${this.formatDate(this.rowData.TAX_YEAR_END)}`);
          this.D_date_flag = true;
          isValid = false;
        } else {
          this.D_date_flag = false;
          this.clearValidationError('sectionD_date');
        }
      } else {
        this.D_date_flag = false;
        this.clearValidationError('sectionD_date');
      }
      
      // Country (required) - AngularJS: angular.isDefined(vm.selectedTabDData[11].VALUE) && vm.selectedTabDData[11].VALUE != null
      const country = this.selectedTabDData[11]?.VALUE;
      if (!country) {
        this.setValidationError('sectionD_country', 'Country is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionD_country');
      }
      
      // US-specific vs non-US validation - AngularJS parity
      if (country?.COUNTRY_CODE === 'US') {
        // US: name, address, city, state, zip all required
        const name = this.selectedTabDData[9]?.VALUE;
        if (!name) {
          this.setValidationError('sectionD_name', 'Name is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionD_name');
        }
        
        const address1 = this.selectedTabDData[12]?.VALUE;
        if (!address1) {
          this.setValidationError('sectionD_address1', 'Address is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionD_address1');
        }
        
        const city = this.selectedTabDData[14]?.VALUE;
        if (!city) {
          this.setValidationError('sectionD_city', 'City is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionD_city');
        }
        
        const state = this.selectedTabDData[15]?.VALUE;
        if (!state) {
          this.setValidationError('sectionD_state', 'State is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionD_state');
        }
        
        const zip = this.selectedTabDData[16]?.VALUE;
        if (!zip) {
          this.setValidationError('sectionD_zip', 'Zip is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionD_zip');
        }
      } else if (country) {
        // Non-US: only name and address required
        const name = this.selectedTabDData[9]?.VALUE;
        if (!name) {
          this.setValidationError('sectionD_name', 'Name is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionD_name');
        }
        
        const address1 = this.selectedTabDData[12]?.VALUE;
        if (!address1) {
          this.setValidationError('sectionD_address1', 'Address is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionD_address1');
        }
        
        this.clearValidationError('sectionD_city');
        this.clearValidationError('sectionD_state');
        this.clearValidationError('sectionD_zip');
      }
    }
    
    if (!isValid) {
      if (this.D_date_flag) {
        this.gtwSnackbarService.openSnackBar(`Date must be between ${this.formatDate(this.rowData.TAX_YEAR_BEGIN)} and ${this.formatDate(this.rowData.TAX_YEAR_END)}.`, 'gtw-snackbar--red');
      } else {
        this.gtwSnackbarService.openSnackBar('Please fill out required fields for Stock Disposition.', 'gtw-snackbar--red');
      }
    }
    
    return isValid;
  }

  private validateSectionE(): boolean {
    this.tabE_flag = true;
    let isValid = true;
    
    if (!this.selectedTabEData || this.selectedTabEData.length === 0) {
      this.setValidationError('sectionE_general', 'Reorganization data is required');
      isValid = false;
    } else {
      // Name Line 1 (required)
      const name = this.selectedTabEData[2]?.VALUE;
      if (!name) {
        this.setValidationError('sectionE_name', 'Name is required');
        isValid = false;
      } else if (!this.validateAlphaNumeric(name)) {
        this.setValidationError('sectionE_name', 'Name contains invalid characters');
        isValid = false;
      } else {
        this.clearValidationError('sectionE_name');
      }
      
      // Country (required)
      const country = this.selectedTabEData[4]?.VALUE;
      if (!country) {
        this.setValidationError('sectionE_country', 'Country is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionE_country');
      }
      
      // Address Line 1 (required)
      const address1 = this.selectedTabEData[5]?.VALUE;
      if (!address1) {
        this.setValidationError('sectionE_address1', 'Address is required');
        isValid = false;
      } else if (!this.validateAlphaNumeric(address1)) {
        this.setValidationError('sectionE_address1', 'Address contains invalid characters');
        isValid = false;
      } else {
        this.clearValidationError('sectionE_address1');
      }
      
      // Date (required)
      const dateValue = this.selectedTabEData[11]?.VALUE;
      if (!dateValue) {
        this.setValidationError('sectionE_date', 'Date is required');
        isValid = false;
      } else {
        this.clearValidationError('sectionE_date');
        // Validate date range
        if (!this.isDateInRange(dateValue)) {
          this.setValidationError('sectionE_date', `Date must be between ${this.formatDate(this.rowData.TAX_YEAR_BEGIN)} and ${this.formatDate(this.rowData.TAX_YEAR_END)}`);
          this.E_date_flag = true;
          isValid = false;
        } else {
          this.E_date_flag = false;
        }
      }
      
      // US-specific validation
      if (country?.COUNTRY_CODE === 'US') {
        // City (required for US)
        const city = this.selectedTabEData[7]?.VALUE;
        if (!city) {
          this.setValidationError('sectionE_city', 'City is required');
          isValid = false;
        } else if (!this.validateAlphaNumeric(city)) {
          this.setValidationError('sectionE_city', 'City contains invalid characters');
          isValid = false;
        } else {
          this.clearValidationError('sectionE_city');
        }
        
        // State (required for US)
        const state = this.selectedTabEData[8]?.VALUE;
        if (!state) {
          this.setValidationError('sectionE_state', 'State is required');
          isValid = false;
        } else {
          this.clearValidationError('sectionE_state');
        }
        
        // Zip (required for US)
        const zip = this.selectedTabEData[9]?.VALUE;
        if (!zip) {
          this.setValidationError('sectionE_zip', 'Zip is required');
          isValid = false;
        } else if (!this.validateZipCode(zip, 'US')) {
          this.setValidationError('sectionE_zip', 'Zip code must contain only numbers');
          isValid = false;
        } else {
          this.clearValidationError('sectionE_zip');
        }
      } else {
        // Clear US-specific validations for non-US countries
        this.clearValidationError('sectionE_city');
        this.clearValidationError('sectionE_state');
        this.clearValidationError('sectionE_zip');
      }
    }
    
    if (!isValid) {
      this.gtwSnackbarService.openSnackBar('Please fill out required(*) fields.', 'gtw-snackbar--red');
    }
    
    return isValid;
  }
  
  // Main 5471 tab validation
  private validateMain5471(): boolean {
    let isValid = true;
    
    if (!this.tab5471Data || this.tab5471Data.length === 0) {
      this.setValidationError('main5471_general', 'Form 5471 data is required');
      isValid = false;
    } else {
      // Date (required)
      const dateValue = this.tab5471Data[0]?.VALUE;
      if (!dateValue) {
        this.setValidationError('main5471_date', 'Date is required');
        isValid = false;
      } else {
        this.clearValidationError('main5471_date');
        // Validate reorganization occurred within the last 4 years
        if (!this.isWithinLast4Years(dateValue)) {
          this.setValidationError('main5471_date', `Date must be within the last 4 years (between ${this.formatLast4YearsStart()} and ${this.formatDate(this.rowData.TAX_YEAR_END)})`);
          this.tab5471_date_flag = true;
          isValid = false;
        } else {
          this.tab5471_date_flag = false;
        }
      }
      
      // Textarea (required)
      const textareaValue = this.tab5471Data[2]?.VALUE;
      if (!textareaValue || textareaValue.trim() === '') {
        this.setValidationError('main5471_textarea', 'Message is required');
        isValid = false;
      } else {
        this.clearValidationError('main5471_textarea');
      }
    }
    
    if (!isValid) {
      this.gtwSnackbarService.openSnackBar('Please fill out required fields.', 'gtw-snackbar--red');
    }
    
    return isValid;
  }




  reset() {
    this.crudLoading = false;
    
    if (this.activeTab === 0) {
      
      if (this.tab5471OriginalData && this.tab5471OriginalData.length > 0) {
        // Deep copy to restore original data
        this.tab5471Data = safeJsonInput<any>(JSON.stringify(this.tab5471OriginalData), null, 'fir-5471-schedule-o.parse13');
      } else {
        // If no original data, clear the form fields
        this.tab5471Data = this.tab5471Data.map(item => ({
          ...item,
          VALUE: null // Clear the VALUE field
        }));
      }
      
      // Force template to update by triggering change detection
      this.tab5471Data = [...this.tab5471Data];
      
    } else {
      // Reset other tabs: Clear tab data
      this.clearTabData(this.activeTab);
    }
    
    this.gtwSnackbarService.openSnackBar('Form has been reset', 'gtw-snackbar--green');
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  // Radio button handler for Yes/No inputs
  onRadioChange(index: number, value: boolean, row: any) {
    row.value = value;
    row.IS_CHANGED_FLAG = 'Y';
    // Call any field visibility logic if needed
    this.fieldVisibility(index, value, row);
  }

  fieldVisibility(index: number, value: boolean, row: any) {
    // Implement field visibility logic here
  }


  onSectionBCheckboxChange(index: number, event: Event) {
    const target = event.target as HTMLInputElement;
    this.selectedTabBData[index] = this.selectedTabBData[index] || {};
    this.selectedTabBData[index].VALUE = target.checked ? '1' : '0';
  }


  onSectionECheckboxChange(index: number, event: Event) {
    const target = event.target as HTMLInputElement;
    this.selectedTabEData[index] = this.selectedTabEData[index] || {};
    this.selectedTabEData[index].VALUE = target.checked ? 'true' : 'false';
    
    // If this is the Corporation Name Change checkbox (index 0)
    if (index === 0) {
      this.tabENameChange();
    }
  }

  tabENameChange() {
    if (this.selectedTabEData[0]?.VALUE === 'true') {
      // Show the alert message
      alert('Please enter the "formerly known as" name in Name Line 1 and 2 and if address is missing, enter LE address to complete a name change transaction.');
      
      // Populate form with corp name change data
      if (this.corpNameChangeData) {
        // Set Person/Business to 'B' (Business)
        this.selectedTabEData[1] = this.selectedTabEData[1] || {};
        this.selectedTabEData[1].VALUE = 'B';
        
        // Set country
        if (this.corpNameChangeData.NAME_CHANGE_COUNTRY_CODE) {
          const country = this.countries.find(c => c.COUNTRY_CODE === this.corpNameChangeData.NAME_CHANGE_COUNTRY_CODE);
          this.selectedTabEData[4] = this.selectedTabEData[4] || {};
          this.selectedTabEData[4].VALUE = country || { COUNTRY_CODE: this.corpNameChangeData.NAME_CHANGE_COUNTRY_CODE };
        }
        
        // Set address line 1
        if (this.corpNameChangeData.NAME_CHANGE_ADDRESS_LINE_1 && this.corpNameChangeData.NAME_CHANGE_ADDRESS_LINE_1 !== 'null') {
          this.selectedTabEData[5] = this.selectedTabEData[5] || {};
          this.selectedTabEData[5].VALUE = this.corpNameChangeData.NAME_CHANGE_ADDRESS_LINE_1;
        }
        
        // Set address line 2
        if (this.corpNameChangeData.NAME_CHANGE_ADDRESS_LINE_2 && this.corpNameChangeData.NAME_CHANGE_ADDRESS_LINE_2 !== 'null') {
          this.selectedTabEData[6] = this.selectedTabEData[6] || {};
          this.selectedTabEData[6].VALUE = this.corpNameChangeData.NAME_CHANGE_ADDRESS_LINE_2;
        }
        
        // Set city
        if (this.corpNameChangeData.NAME_CHANGE_CITY && this.corpNameChangeData.NAME_CHANGE_CITY !== 'null') {
          this.selectedTabEData[7] = this.selectedTabEData[7] || {};
          this.selectedTabEData[7].VALUE = this.corpNameChangeData.NAME_CHANGE_CITY;
        }
        
        // Set state
        if (this.corpNameChangeData.NAME_CHANGE_STATE && this.corpNameChangeData.NAME_CHANGE_STATE !== 'null') {
          this.selectedTabEData[8] = this.selectedTabEData[8] || {};
          if (this.corpNameChangeData.NAME_CHANGE_COUNTRY_CODE === 'US') {
            const state = this.states.find(s => s.code === this.corpNameChangeData.NAME_CHANGE_STATE);
            this.selectedTabEData[8].VALUE = state || this.corpNameChangeData.NAME_CHANGE_STATE;
          } else {
            this.selectedTabEData[8].VALUE = this.corpNameChangeData.NAME_CHANGE_STATE;
          }
        }
        
        // Set postal code
        if (this.corpNameChangeData.NAME_CHANGE_POSTAL_CODE && this.corpNameChangeData.NAME_CHANGE_POSTAL_CODE !== 'null') {
          this.selectedTabEData[9] = this.selectedTabEData[9] || {};
          this.selectedTabEData[9].VALUE = this.corpNameChangeData.NAME_CHANGE_POSTAL_CODE;
        }
        
        // Set identifying number
        if (this.corpNameChangeData.NAME_CHANGE_EIN && this.corpNameChangeData.NAME_CHANGE_EIN !== 'null') {
          this.selectedTabEData[10] = this.selectedTabEData[10] || {};
          this.selectedTabEData[10].VALUE = this.corpNameChangeData.NAME_CHANGE_EIN;
          this.selectedTabEData[10].DISVALUE = this.corpNameChangeData.NAME_CHANGE_EIN;
        }
        
        // Set description of assets
        this.selectedTabEData[12] = this.selectedTabEData[12] || {};
        this.selectedTabEData[12].VALUE = "Corporation Name Change";
        
        // Set fair market value and adjusted basis to 0
        this.selectedTabEData[13] = this.selectedTabEData[13] || {};
        this.selectedTabEData[13].VALUE = 0;
        
        this.selectedTabEData[14] = this.selectedTabEData[14] || {};
        this.selectedTabEData[14].VALUE = 0;
        
        // Clear description of assets transferred
        this.selectedTabEData[15] = this.selectedTabEData[15] || {};
        this.selectedTabEData[15].VALUE = null;
      }
    } else {
      // When unchecked, restore original data if in edit mode
      if (this.editFlag && this.selectedTabEOriginalData && this.selectedTabEOriginalData.length > 0) {
        this.selectedTabEData = safeJsonInput<any>(JSON.stringify(this.selectedTabEOriginalData), null, 'fir-5471-schedule-o.parse14');
      } else {
        // Clear tab data
        this.clearTabData(3);
      }
    }
  }

  onSectionEIdentifyingNumberChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.selectedTabEData[10] = this.selectedTabEData[10] || {};
    this.selectedTabEData[10].DISVALUE = target.value;
    // Clear radio buttons when user types in the field
    if (target.value) {
      this.selectedTabEData[16] = this.selectedTabEData[16] || {};
      this.selectedTabEData[16].VALUE = null;
    }
  }

  onSectionEIdentifyingRadioChange(value: string) {
    this.selectedTabEData[16] = this.selectedTabEData[16] || {};
    this.selectedTabEData[16].VALUE = value;
    // Clear the text field when radio is selected
    this.selectedTabEData[10] = this.selectedTabEData[10] || {};
    this.selectedTabEData[10].DISVALUE = null;
  }

  // Data preparation methods for saving
  private getScheduleSettings() {
    return [{
      "tax_year": this.filterParams?.tax_year || this.globalService?.globalParams?.tax_year,
      "scenario": this.filterParams?.scenario || this.globalService?.globalParams?.scenario,
      "jcd_key": (this.globalService?.globalParams?.jcd_key === '' || this.globalService?.globalParams?.jcd_key === undefined) ? '250' : this.globalService?.globalParams?.jcd_key
    }];
  }

  prepareSaveDataFor5471() {
    // Use tab5471Data directly like AngularJS
    const scheduleSettings = this.getScheduleSettings();
    const editRow: any[] = [];

    // Iterate over tab5471Data directly
    for (let i = 0; i < this.tab5471Data.length; i++) {
      // Skip if no data at this index
      if (!this.tab5471Data[i]) {
        continue;
      }

      // AngularJS value determination logic
      let value = null;
      
      if (this.tab5471Data[i].attrib_name === 'REORGANIZATION_DATE') {
        value = (this.tab5471Data[i].VALUE != null ? this.formatDateForSave(this.tab5471Data[i].VALUE) : null);
      } else {
        if (this.tab5471Data[i].VALUE !== undefined && 
            this.tab5471Data[i].VALUE !== null && 
            this.tab5471Data[i].VALUE.toString().length > 0) {
          value = this.tab5471Data[i].VALUE;
        } else {
          value = null;
        }
      }

      // AngularJS tempJsonObj structure - using tab5471Data[i] directly for ALL metadata
      const tempJsonObj = [{
        "tax_year": scheduleSettings[0].tax_year,
        "trans_type_key": this.tab5471Data[i].trans_type_key,
        "combination_key": this.rowData?.HO_COMBINATION_KEY,
        "group_obj_key": this.rowData?.GROUP_OBJ_KEY,
        "form_key": this.tab5471Data[i].form_key,
        "line_no": this.tab5471Data[i].line_no,
        "occurence": ((this.tab5471Data[i].occurrence == "0") ? null : this.tab5471Data[i].occurrence),
        "line_attrib_key": this.tab5471Data[i].line_attrib_key,
        "Attribute_Name": this.tab5471Data[i].attrib_name,
        "Attribute_Value": value,
        "trans_dtls_key": ((this.tab5471Data[i].trans_details_key == "0") ? null : this.tab5471Data[i].trans_details_key),
        "trans_status": "A"
      }];
      
      editRow.push(tempJsonObj);
    }

    const scheduleDetails = {"addrows": [], "editrows": editRow, "removerows": []};

    return {
      scheduleSettings: scheduleSettings,
      scheduleDetails: scheduleDetails
    };
  }


  // Main 5471 tab input change handlers
  onTab5471InputChange(index: number, event: any) {
    const value = (event.target as HTMLInputElement).value;
    
    // If tab5471Data doesn't exist at this index, store user input temporarily until API loads
    if (!this.tab5471Data[index]) {
      if (!this.tempUserInput) {
        this.tempUserInput = {};
      }
      this.tempUserInput[index] = value;
      return;
    }
    
    // Update VALUE while preserving metadata
    this.tab5471Data[index].VALUE = value;
    
    switch(index) {
      case 0:
        this.clearValidationError('main5471_date');
        if (value && !this.isWithinLast4Years(value)) {
          this.setValidationError('main5471_date', `Date must be within the last 4 years (between ${this.formatLast4YearsStart()} and ${this.formatDate(this.rowData.TAX_YEAR_END)})`);
          this.tab5471_date_flag = true;
        } else {
          this.tab5471_date_flag = false;
        }
        break;
      case 2: this.clearValidationError('main5471_textarea'); break;
    }
  }

  onTab5471CheckboxChange(index: number, event: any) {
    const checked = (event.target as HTMLInputElement).checked;
    const value = checked ? 'Y' : 'N';
    
    // If tab5471Data doesn't exist at this index, store user input temporarily until API loads
    if (!this.tab5471Data[index]) {
      if (!this.tempUserInput) {
        this.tempUserInput = {};
      }
      this.tempUserInput[index] = value;
      return;
    }
    
    // Update VALUE while preserving metadata
    this.tab5471Data[index].VALUE = value;
    
    // Clear validation errors
    this.clearValidationError('main5471_checkbox');
  }


  prepareSaveDataForSectionB() {
    
    const scheduleSettings = this.getScheduleSettings();
    const editRow: any[] = [];
    
    for (let i = 0; i < this.selectedTabBData.length; i++) {
      // EXACT AngularJS logic: value starts as null
      let value = null;
      
       // EXACT field-specific logic from AngularJS
       if (this.selectedTabBData[i]?.attrib_name == '5471_O_US_PER_OFF_DIR_F_COUNTRY') {
        value = this.selectedTabBData[i]?.VALUE?.COUNTRY_CODE;
      }
       else if (this.selectedTabBData[i]?.attrib_name == '5471_O_US_PER_OFF_DIR_US_STATE' || 
                this.selectedTabBData[i]?.attrib_name == '5471_O_US_PER_OFF_DIR_F_STATE') {
        
        if (this.selectedTabBData[i]?.VALUE != null && this.selectedTabBData[i]?.VALUE?.code !== undefined) {
          // US State object - extract code (EXACT same logic as Section C)
          value = this.selectedTabBData[i].VALUE.code;
        }
        else if (this.selectedTabBData[i]?.VALUE !== undefined && 
                 (this.selectedTabBData[i]?.VALUE != null && this.selectedTabBData[i]?.VALUE.toString().length > 0)) {
          // Foreign State string or other value (EXACT same logic as Section C)
          value = this.selectedTabBData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      else {
        // For all other fields
        if (this.selectedTabBData[i]?.VALUE !== undefined && 
            (this.selectedTabBData[i]?.VALUE != null && this.selectedTabBData[i]?.VALUE.toString().length > 0)) {
          value = this.selectedTabBData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      
      const tempJsonObj = [{
        "tax_year": scheduleSettings[0].tax_year,
        "trans_type_key": this.selectedTabBData[i]?.trans_type_key?.toString() || "1231",
        "combination_key": this.rowData?.HO_COMBINATION_KEY,
        "group_obj_key": this.rowData?.GROUP_OBJ_KEY,
        "form_key": this.selectedTabBData[i]?.form_key?.toString() || "987",
        "line_no": this.selectedTabBData[i]?.line_no?.toString() || "6",
        "occurence": this.selectedTabBData[i]?.occurrence?.toString() || "3",
        "line_attrib_key": this.selectedTabBData[i]?.line_attrib_key?.toString() || "0",
         "Attribute_Name": this.selectedTabBData[i]?.attrib_name,
        "Attribute_Value": value,
        "trans_dtls_key": this.selectedTabBData[i]?.trans_details_key || null,
        "trans_status": "A"
      }];
      editRow.push(tempJsonObj);
    }
    
    const scheduleDetails = {"addrows": [], "editrows": editRow, "removerows": []};
    
    return {
      scheduleSettings: scheduleSettings,
      scheduleDetails: scheduleDetails
    };
  }

  prepareSaveDataForSectionC() {
    
    const scheduleSettings = this.getScheduleSettings();
    const editRow: any[] = [];
    
    for (let i = 0; i < this.selectedTabCData.length; i++) {
      // EXACT AngularJS logic: value starts as null
      let value = null;
      
      // EXACT field-specific logic from AngularJS
      if (this.selectedTabCData[i]?.attrib_name == 'NAME_OF_SHAREHOLDER_FILING') {
        value = this.selectedTabCData[i]?.VALUE?.LEGAL_ENTITY_ID;
      }
      else if (this.selectedTabCData[i]?.attrib_name == 'DATE_OF_ACQUISITION') {
        value = (this.selectedTabCData[i]?.VALUE != null ? this.formatDateForSave(this.selectedTabCData[i].VALUE) : null);
      }
      else if (this.selectedTabCData[i]?.attrib_name == 'COUNTRY') {
        value = this.selectedTabCData[i]?.VALUE?.COUNTRY_CODE;
      }
      else if (this.selectedTabCData[i]?.attrib_name == 'STATE' || 
               this.selectedTabCData[i]?.attrib_name == '5471_O_STOCK_ACQ_F_STATE') {
        if (this.selectedTabCData[i]?.VALUE != null && this.selectedTabCData[i]?.VALUE?.code !== undefined) {
          value = this.selectedTabCData[i].VALUE.code;
        }
        else if (this.selectedTabCData[i]?.VALUE !== undefined && 
                 (this.selectedTabCData[i]?.VALUE != null && this.selectedTabCData[i]?.VALUE.toString().length > 0)) {
          value = this.selectedTabCData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      else {
        // For all other fields
        if (this.selectedTabCData[i]?.VALUE !== undefined && 
            (this.selectedTabCData[i]?.VALUE != null && this.selectedTabCData[i]?.VALUE.toString().length > 0)) {
          value = this.selectedTabCData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      
      const tempJsonObj = [{
        "tax_year": scheduleSettings[0].tax_year,
        "trans_type_key": this.selectedTabCData[i]?.trans_type_key,
        "combination_key": this.rowData?.HO_COMBINATION_KEY,
        "group_obj_key": this.rowData?.GROUP_OBJ_KEY,
        "form_key": this.selectedTabCData[i]?.form_key,
        "line_no": this.selectedTabCData[i]?.line_no,
        "occurence": ((this.selectedTabCData[i]?.occurrence == "0") ? null : this.selectedTabCData[i]?.occurrence),
        "line_attrib_key": this.selectedTabCData[i]?.line_attrib_key,
        "Attribute_Name": this.selectedTabCData[i]?.attrib_name,
        "Attribute_Value": value,
        "trans_dtls_key": ((this.selectedTabCData[i]?.trans_details_key == "0") ? null : this.selectedTabCData[i]?.trans_details_key),
        "trans_status": "A"
      }];
      editRow.push(tempJsonObj);
    }
    
    const scheduleDetails = {"addrows": [], "editrows": editRow, "removerows": []};
    
    return {
      scheduleSettings: scheduleSettings,
      scheduleDetails: scheduleDetails
    };
  }

  prepareSaveDataForSectionD() {
    
    const scheduleSettings = this.getScheduleSettings();
    const editRow: any[] = [];
    
    for (let i = 0; i < this.selectedTabDData.length; i++) {
      // EXACT AngularJS logic: value starts as null
      let value = null;
      
      // EXACT field-specific logic from AngularJS
      if (this.selectedTabDData[i]?.attrib_name == 'NAME_OF_SHAREHOLDER_DISPOSING') {
        value = this.selectedTabDData[i]?.VALUE?.LEGAL_ENTITY_ID;
      }
      else if (this.selectedTabDData[i]?.attrib_name == 'DATE_OF_DISPOSITION') {
        value = (this.selectedTabDData[i]?.VALUE != null ? this.formatDateForSave(this.selectedTabDData[i].VALUE) : null);
      }
      else if (this.selectedTabDData[i]?.attrib_name == 'COUNTRY') {
        value = this.selectedTabDData[i]?.VALUE?.COUNTRY_CODE;
      }
      else if (this.selectedTabDData[i]?.attrib_name == 'STATE' || 
               this.selectedTabDData[i]?.attrib_name == '5471_O_STOCK_DIS_F_STATE') {
        if (this.selectedTabDData[i]?.VALUE != null && this.selectedTabDData[i]?.VALUE?.code !== undefined) {
          value = this.selectedTabDData[i].VALUE.code;
        }
        else if (this.selectedTabDData[i]?.VALUE !== undefined && 
                 (this.selectedTabDData[i]?.VALUE != null && this.selectedTabDData[i]?.VALUE.toString().length > 0)) {
          value = this.selectedTabDData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      else {
        // For all other fields
        if (this.selectedTabDData[i]?.VALUE !== undefined && 
            (this.selectedTabDData[i]?.VALUE != null && this.selectedTabDData[i]?.VALUE.toString().length > 0)) {
          value = this.selectedTabDData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      
      const tempJsonObj = [{
        "tax_year": scheduleSettings[0].tax_year,
        "trans_type_key": this.selectedTabDData[i]?.trans_type_key,
        "combination_key": this.rowData?.HO_COMBINATION_KEY,
        "group_obj_key": this.rowData?.GROUP_OBJ_KEY,
        "form_key": this.selectedTabDData[i]?.form_key,
        "line_no": this.selectedTabDData[i]?.line_no,
        "occurence": ((this.selectedTabDData[i]?.occurrence == "0") ? null : this.selectedTabDData[i]?.occurrence),
        "line_attrib_key": this.selectedTabDData[i]?.line_attrib_key,
        "Attribute_Name": this.selectedTabDData[i]?.attrib_name,
        "Attribute_Value": value,
        "trans_dtls_key": ((this.selectedTabDData[i]?.trans_details_key == "0") ? null : this.selectedTabDData[i]?.trans_details_key),
        "trans_status": "A"
      }];
      editRow.push(tempJsonObj);
    }
    
    const scheduleDetails = {"addrows": [], "editrows": editRow, "removerows": []};
    
    return {
      scheduleSettings: scheduleSettings,
      scheduleDetails: scheduleDetails
    };
  }

  prepareSaveDataForSectionE() {
    
    const scheduleSettings = this.getScheduleSettings();
    const editRow: any[] = [];
    
    for (let i = 0; i < this.selectedTabEData.length; i++) {
      // EXACT AngularJS logic: value starts as null
      let value = null;
      
      // EXACT field-specific logic from AngularJS
      if (this.selectedTabEData[i]?.attrib_name == 'DATE_OF_TRANSFER') {
        value = (this.selectedTabEData[i]?.VALUE != null ? this.formatDateForSave(this.selectedTabEData[i].VALUE) : null);
      }
      else if (this.selectedTabEData[i]?.attrib_name == 'COUNTRY') {
        value = this.selectedTabEData[i]?.VALUE?.COUNTRY_CODE;
      }
      else if (this.selectedTabEData[i]?.attrib_name == 'STATE') {
        if (this.selectedTabEData[i]?.VALUE != null && this.selectedTabEData[i]?.VALUE?.code !== undefined) {
          value = this.selectedTabEData[i].VALUE.code;
        }
        else if (this.selectedTabEData[i]?.VALUE !== undefined && 
                 (this.selectedTabEData[i]?.VALUE != null && this.selectedTabEData[i]?.VALUE.toString().length > 0)) {
          value = this.selectedTabEData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      else if (this.selectedTabEData[i]?.attrib_name == 'IDENTIFYING_NUMBER' || 
               this.selectedTabEData[i]?.attrib_name == '5471_O_ORG_REORG_MISSING_EIN_REASON') {
        if ((this.selectedTabEData[i]?.VALUE != null || this.selectedTabEData[i]?.DISVALUE != null)) {
          if (this.selectedTabEData[i]?.DISVALUE != null && this.selectedTabEData[i]?.DISVALUE.toString().length > 0) {
            if (this.selectedTabEData[i].DISVALUE && this.selectedTabEData[i].DISVALUE.length > 2) {
              value = this.selectedTabEData[i].DISVALUE.substr(0, 2) + '-' + this.selectedTabEData[i].DISVALUE.substr(2, this.selectedTabEData[i].DISVALUE.length);
            }
            else {
              value = this.selectedTabEData[i].DISVALUE;
            }
          }
          else if (this.selectedTabEData[i]?.VALUE != null && this.selectedTabEData[i]?.VALUE.toString().length > 0) {
            value = this.selectedTabEData[i].VALUE;
          }
          else {
            value = null;
          }
        }
        else {
          value = null;
        }
      }
      else {
        // For all other fields
        if (this.selectedTabEData[i]?.VALUE !== undefined && 
            (this.selectedTabEData[i]?.VALUE != null && this.selectedTabEData[i]?.VALUE.toString().length > 0)) {
          value = this.selectedTabEData[i].VALUE;
        }
        else {
          value = null;
        }
      }
      
      const tempJsonObj = [{
        "tax_year": scheduleSettings[0].tax_year,
        "trans_type_key": this.selectedTabEData[i]?.trans_type_key,
        "combination_key": this.rowData?.HO_COMBINATION_KEY,
        "group_obj_key": this.rowData?.GROUP_OBJ_KEY,
        "form_key": this.selectedTabEData[i]?.form_key,
        "line_no": this.selectedTabEData[i]?.line_no,
        "occurence": ((this.selectedTabEData[i]?.occurrence == "0") ? null : this.selectedTabEData[i]?.occurrence),
        "line_attrib_key": this.selectedTabEData[i]?.line_attrib_key,
        "Attribute_Name": this.selectedTabEData[i]?.attrib_name,
        "Attribute_Value": value,
        "trans_dtls_key": ((this.selectedTabEData[i]?.trans_details_key == "0") ? null : this.selectedTabEData[i]?.trans_details_key),
        "trans_status": "A"
      }];
      editRow.push(tempJsonObj);
    }
    
    const scheduleDetails = {"addrows": [], "editrows": editRow, "removerows": []};
    
    console.log('Prepared Section E save data:');
    console.log('scheduleSettings:', scheduleSettings);
    console.log('scheduleDetails:', scheduleDetails);
    
    return {
      scheduleSettings: scheduleSettings,
      scheduleDetails: scheduleDetails
    };
  }

  private formatDateForSave(dateValue: any): string | null {
    if (!dateValue) return null;
    
    try {
      // Use parseAsLocalDate to avoid UTC timezone shift: new Date("YYYY-MM-DD")
      // parses as UTC midnight, which shifts the date by -1 day in US timezones
      const date = parseAsLocalDate(String(dateValue));
      if (!date || isNaN(date.getTime())) return null;
      
      // Format as MM/dd/yyyy to match original AngularJS format
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();
      
      return `${month}/${day}/${year}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return null;
    }
  }

  // Section A save method - matching AngularJS logic exactly
  sectionAInfo() {
    if (!this.validateSectionA()) {
      return;
    }

    this.startApiCall();

    try {
      const saveData = this.prepareSaveDataForSectionA();
      
      this.fir5471ScheduleOService.saveScheduleO(
        this.GENERAL_CONFIG.base_url,
        saveData.scheduleSettings,
        saveData.scheduleDetails,
        this.globalService,
        this.filterParams,
        this.rowData
      ).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (result: any) => {
          this.handleSaveResponse(result, 'Section A is successfully saved');
        },
        (error: any) => {
          this.handleSaveError(error);
        }
      );
    } catch (error) {
      console.error('Error in sectionAInfo:', error);
      this.handleSaveError(error);
    }
  }

  prepareSaveDataForSectionA() {
    const scheduleSettings = this.getScheduleSettings();
    const editRow: any[] = [];

    // Check if selectedTabAData has required metadata
    if (this.selectedTabAData.length === 0) {
      console.error('selectedTabAData is empty - cannot save Section A');
      return { scheduleSettings: scheduleSettings, scheduleDetails: {"addrows": [], "editrows": [], "removerows": []} };
    }

    // Check if first item has required metadata
    const firstItem = this.selectedTabAData[0];
    if (!firstItem.trans_type_key || !firstItem.form_key || !firstItem.line_attrib_key || !firstItem.attrib_name) {
      console.error('selectedTabAData missing required metadata:', firstItem);
      console.error('Required fields: trans_type_key, form_key, line_attrib_key, attrib_name');
      return { scheduleSettings: scheduleSettings, scheduleDetails: {"addrows": [], "editrows": [], "removerows": []} };
    }

    for (let i = 0; i < this.selectedTabAData.length; i++) {
      let value = null;
      
      if (this.selectedTabAData[i].attrib_name === '5471_O_GEN_SH_LAST_FILED') {
        value = (this.selectedTabAData[i].VALUE != null ? this.formatDateForSave(this.selectedTabAData[i].VALUE) : null);
      }

      const tempJsonObj = [{
        "tax_year": scheduleSettings[0].tax_year,
        "trans_type_key": this.selectedTabAData[i].trans_type_key,
        "combination_key": this.rowData?.HO_COMBINATION_KEY,
        "group_obj_key": this.rowData?.GROUP_OBJ_KEY,
        "form_key": this.selectedTabAData[i].form_key,
        "line_no": this.selectedTabAData[i].line_no,
        "occurence": ((this.selectedTabAData[i].occurrence == "0") ? null : this.selectedTabAData[i].occurrence),
        "line_attrib_key": this.selectedTabAData[i].line_attrib_key,
        "Attribute_Name": this.selectedTabAData[i].attrib_name,
        "Attribute_Value": value,
        "trans_dtls_key": ((this.selectedTabAData[i].trans_details_key == "0") ? null : this.selectedTabAData[i].trans_details_key),
        "trans_status": "A"
      }];
      
      editRow.push(tempJsonObj);
    }

    const scheduleDetails = {"addrows": [], "editrows": editRow, "removerows": []};

    return {
      scheduleSettings: scheduleSettings,
      scheduleDetails: scheduleDetails
    };
  }

  // Section table action methods
  editSchedule(item: any, section: string) {
    
    this.editFlag = true;
    this.crudLoading = true;
    
    // EXACT AngularJS logic: Complex data transformation for each section
    switch(section) {
      case 'A':
        this.activeTab = 5; // Section A tab
        this.selectedTabAData = [];
        this.tempOldscheduleData = [];
        
        for (let i = 0; i < item.length; i++) {
          let value = null;
          
          if (item[i].attrib_name == "5471_O_GEN_SH_LAST_FILED") {
            if (item[i].VALUE != null) {
              const dateSet = parseAsLocalDate(String(item[i].VALUE));
              if (dateSet) {
                const year = dateSet.getFullYear();
                const month = String(dateSet.getMonth() + 1).padStart(2, '0');
                const day = String(dateSet.getDate()).padStart(2, '0');
                value = `${year}-${month}-${day}`;
              }
            }
          } else {
            value = item[i].VALUE;
          }
          
          this.selectedTabAData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "trans_type_key": item[i].trans_type_key
          };
          
          this.tempOldscheduleData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "trans_type_key": item[i].trans_type_key
          };
        }
        
        break;
        
        case 'B':
          this.activeTab = 4; // Section B tab
          
          const fieldIndexMap: { [key: string]: number } = {
            '5471_O_US_PER_OFF_DIR_NAME_1': 0,
            '5471_O_US_PER_OFF_DIR_NAME_2': 1,
            '5471_O_US_PER_OFF_DIR_F_COUNTRY': 2,
            'COUNTRY': 2, // Alternative country field name
            '5471_O_US_PER_OFF_DIR_US_ADDR_1': 3,
            '5471_O_US_PER_OFF_DIR_F_ADDR_1': 3,
            '5471_O_US_PER_OFF_DIR_US_ADDR_2': 4,
            '5471_O_US_PER_OFF_DIR_F_ADDR_2': 4,
            '5471_O_US_PER_OFF_DIR_US_CITY': 5,
            '5471_O_US_PER_OFF_DIR_F_CITY': 5,
            '5471_O_US_PER_OFF_DIR_US_STATE': 6,
            '5471_O_US_PER_OFF_DIR_F_STATE': 6,
            '5471_O_US_PER_OFF_DIR_US_ZIP': 7,
            '5471_O_US_PER_OFF_DIR_F_ZIP': 7,
            '5471_O_US_PER_OFF_DIR_SSN': 8,
            '5471_O_US_PER_OFF_DIR_OFFICER': 9,
            '5471_O_US_PER_OFF_DIR_DIRECTOR': 10
          };
          
          // Initialize arrays with correct size
          this.selectedTabBData = new Array(11);
          this.tempOldscheduleData = new Array(11);
          
          // Map each saved item to its correct index
          console.log('🔧 Section B Edit: Mapping saved items to form indices');
          console.log('🔧 Available saved items:', item.map((i: any) => ({ attrib_name: i.attrib_name, VALUE: i.VALUE })));
          
          for (let i = 0; i < item.length; i++) {
            const savedItem = item[i];
            const correctIndex = fieldIndexMap[savedItem.attrib_name];
            
            console.log(`🔧 Processing saved item [${i}]: ${savedItem.attrib_name} → index ${correctIndex}, VALUE:`, savedItem.VALUE);
            
            if (correctIndex !== undefined) {
              // Transform values for form display
              let displayValue = savedItem.VALUE;
              
              // Handle checkbox values
              if (savedItem.attrib_name === "5471_O_US_PER_OFF_DIR_OFFICER" || 
                  savedItem.attrib_name === "5471_O_US_PER_OFF_DIR_DIRECTOR") {
                displayValue = (savedItem.VALUE === 'Y' || savedItem.VALUE === '1') ? '1' : '0';
              }
              // Handle country field - convert string to object
              else if (savedItem.attrib_name.includes("COUNTRY")) {
                if (typeof savedItem.VALUE === 'string') {
                  displayValue = this.getCountryInfo(savedItem.VALUE);
                }
              }
              // Handle state field - convert string to object
              else if (savedItem.attrib_name.includes("STATE")) {
                
                if (typeof savedItem.VALUE === 'string' && savedItem.VALUE) {
                  displayValue = this.getStateInfo(savedItem.VALUE);
                } else {
                  displayValue = savedItem.VALUE;
                }
              }
              
              // Place field at correct index with original data preserved
              this.selectedTabBData[correctIndex] = {
                line_no: savedItem.line_no,
                line_attrib_key: savedItem.line_attrib_key,
                attrib_name: savedItem.attrib_name,
                attrib_description: savedItem.attrib_description || savedItem.attrib_name,
                form_key: savedItem.form_key,
                trans_details_key: savedItem.trans_details_key,
                occurrence: savedItem.occurrence, // Preserve original occurrence
                VALUE: displayValue,
                trans_type_key: savedItem.trans_type_key
              };
              
              this.tempOldscheduleData[correctIndex] = { 
                ...savedItem, 
                VALUE: displayValue
              };
            } else {
              console.warn(`Unknown field name: ${savedItem.attrib_name}`);
            }
          }
          
          break;
        
      case 'C':
        this.activeTab = 1; // Section C tab
        this.selectedTabCData = [];
        this.tempOldscheduleData = [];
        
        for (let i = 0; i < item.length; i++) {
          let value = null;
          
          if (item[i].attrib_name == 'PERSON_BUSINESS_VALUE') {
            if (!(item[i].VALUE) || item[i].VALUE == null) {
              value = "B";
            } else {
              value = item[i].VALUE;
            }
          }
          else if (item[i].attrib_name == "DATE_OF_ACQUISITION") {
            // Date conversion for UI display - format as YYYY-MM-DD string for HTML date input
            if (item[i].VALUE != null) {
              const dateSet = parseAsLocalDate(String(item[i].VALUE));
              if (dateSet) {
                const year = dateSet.getFullYear();
                const month = String(dateSet.getMonth() + 1).padStart(2, '0');
                const day = String(dateSet.getDate()).padStart(2, '0');
                value = `${year}-${month}-${day}`;
              }
            }
          }
          else if (item[i].attrib_name == "NAME_OF_SHAREHOLDER_FILING") {
            // If shareholder entity id is not defined, get default entity info
            if (!(item[i].VALUE) || item[i].VALUE == null) {
              value = {};
            } else {
              value = item[i].VALUE;
            }
          }
          else {
            value = item[i].VALUE;
          }
          
          this.selectedTabCData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "trans_type_key": item[i].trans_type_key
          };
          
          this.tempOldscheduleData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "trans_type_key": item[i].trans_type_key
          };
        }
        break;
        
      case 'D':
        this.activeTab = 2; // Section D tab
        this.selectedTabDData = [];
        this.tempOldscheduleData = [];
        
        for (let i = 0; i < item.length; i++) {
          let value = null;
          
          // Section D specific transformations (same as C but for disposition)
          if (item[i].attrib_name == 'PERSON_BUSINESS_VALUE') {
            if (!(item[i].VALUE) || item[i].VALUE == null) {
              value = "B";
            } else {
              value = item[i].VALUE;
            }
          }
          else if (item[i].attrib_name == "DATE_OF_DISPOSITION") {
            // Date conversion for UI display - format as YYYY-MM-DD string for HTML date input
            if (item[i].VALUE != null) {
              const dateSet = parseAsLocalDate(String(item[i].VALUE));
              if (dateSet) {
                const year = dateSet.getFullYear();
                const month = String(dateSet.getMonth() + 1).padStart(2, '0');
                const day = String(dateSet.getDate()).padStart(2, '0');
                value = `${year}-${month}-${day}`;
              }
            }
          }
          else if (item[i].attrib_name == "NAME_OF_SHAREHOLDER_DISPOSING") {
            // If shareholder entity id is not defined, get default entity info
            if (!(item[i].VALUE) || item[i].VALUE == null) {
              value = {};
            } else {
              value = item[i].VALUE;
            }
          }
          else {
            value = item[i].VALUE;
          }
          
          this.selectedTabDData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "trans_type_key": item[i].trans_type_key
          };
          
          this.tempOldscheduleData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "trans_type_key": item[i].trans_type_key
          };
        }
        break;
        
      case 'E':
        this.activeTab = 3; // Section E tab
        this.selectedTabEData = [];
        this.tempOldscheduleData = [];
        
        for (let i = 0; i < item.length; i++) {
          let value = null;
          let disValue = null;
          
          // Section E specific transformations
          if (item[i].attrib_name == 'PERSON_BUSINESS_VALUE') {
            if (!(item[i].VALUE) || item[i].VALUE == null) {
              value = "B";
            } else {
              value = item[i].VALUE;
            }
          }
          else if (item[i].attrib_name == "DATE_OF_TRANSFER") {
            // Date conversion for UI display - format as YYYY-MM-DD string for HTML date input
            if (item[i].VALUE != null) {
              const dateSet = parseAsLocalDate(String(item[i].VALUE));
              if (dateSet) {
                const year = dateSet.getFullYear();
                const month = String(dateSet.getMonth() + 1).padStart(2, '0');
                const day = String(dateSet.getDate()).padStart(2, '0');
                value = `${year}-${month}-${day}`;
              }
            }
          }
          else if (item[i].attrib_name == "IDENTIFYING_NUMBER") {
            if (item[i].VALUE != null) {
              if (item[i].VALUE == 'APPLD FOR' || item[i].VALUE == 'FOREIGNUS') {
                disValue = null;
                value = item[i].VALUE;
              } else {
                value = item[i].VALUE;
                disValue = item[i].VALUE.replace('-', '');
              }
            }
          }
          else {
            value = item[i].VALUE;
          }
          
          this.selectedTabEData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "DISVALUE": disValue,
            "trans_type_key": item[i].trans_type_key
          };
          
          this.tempOldscheduleData[i] = {
            "line_no": item[i].line_no,
            "line_attrib_key": item[i].line_attrib_key,
            "attrib_name": item[i].attrib_name,
            "attrib_description": item[i].attrib_description,
            "trans_details_key": item[i].trans_details_key,
            "occurrence": item[i].occurrence,
            "form_key": item[i].form_key,
            "VALUE": value,
            "DISVALUE": disValue,
            "trans_type_key": item[i].trans_type_key
          };
        }
        break;
    }
    
    this.crudLoading = false;
  }

  deleteSchedule(item: any, section: string) {

    if (confirm('Are you sure you want to delete this item?')) {
      this.deletingItem = item;
      const scheduleSettings = this.getScheduleSettings();
      const removeRow: any[] = [];
      
      for (let i = 0; i < item.length; i++) {
        let value = null;
        
        if (item[i].attrib_name == 'NAME_OF_SHAREHOLDER_FILING' || 
            item[i].attrib_name == 'NAME_OF_SHAREHOLDER_DISPOSING') {
          value = item[i].VALUE?.LEGAL_ENTITY_ID;
        }
        else if (item[i].attrib_name == 'DATE_OF_ACQUISITION' || 
                 item[i].attrib_name == 'DATE_OF_DISPOSITION' ||
                 item[i].attrib_name == 'DATE_OF_TRANSFER' ||
                 item[i].attrib_name == '5471_O_GEN_SH_LAST_FILED') {
          value = (item[i].VALUE != null ? this.formatDateForSave(item[i].VALUE) : null);
        }
        else if (item[i].attrib_name == 'COUNTRY' || 
                 item[i].attrib_name == '5471_O_US_PER_OFF_DIR_F_COUNTRY') {
          value = item[i].VALUE?.COUNTRY_CODE;
        }
        else if (item[i].attrib_name == 'STATE' || 
                 item[i].attrib_name == '5471_O_US_PER_OFF_DIR_US_STATE' ||
                 item[i].attrib_name == '5471_O_STOCK_ACQ_F_STATE' ||
                 item[i].attrib_name == '5471_O_STOCK_DIS_F_STATE' ||
                 item[i].attrib_name == '5471_O_ORG_REORG_F_STATE') {
          if (item[i].VALUE != null && item[i].VALUE?.code !== undefined) {
            value = item[i].VALUE.code;
          }
          else if (item[i].VALUE !== undefined && 
                   (item[i].VALUE != null && item[i].VALUE.toString().length > 0)) {
            value = item[i].VALUE;
          }
          else {
            value = null;
          }
        }
        else if (item[i].attrib_name == 'IDENTIFYING_NUMBER' || 
                 item[i].attrib_name == '5471_O_ORG_REORG_MISSING_EIN_REASON') {
          if ((item[i].VALUE != null || item[i].DISVALUE != null)) {
            if (item[i].DISVALUE != null && item[i].DISVALUE.toString().length > 0) {
              if (item[i].DISVALUE && item[i].DISVALUE.length > 2) {
                value = item[i].DISVALUE.substr(0, 2) + '-' + item[i].DISVALUE.substr(2, item[i].DISVALUE.length);
              } else {
                value = item[i].DISVALUE;
              }
            }
            else if (item[i].VALUE != null && item[i].VALUE.toString().length > 0) {
              value = item[i].VALUE;
            }
            else {
              value = null;
            }
          }
          else {
            value = null;
          }
        }
        else {
          if (item[i].VALUE !== undefined && 
              (item[i].VALUE != null && item[i].VALUE.toString().length > 0)) {
            value = item[i].VALUE;
          }
          else {
            value = null;
          }
        }
        
        const tempJsonObj = [{
          "tax_year": scheduleSettings[0].tax_year,
          "trans_type_key": item[i].trans_type_key,
          "combination_key": this.rowData?.HO_COMBINATION_KEY,
          "group_obj_key": this.rowData?.GROUP_OBJ_KEY,
          "form_key": item[i].form_key,
          "line_no": item[i].line_no,
          "occurence": ((item[i].occurrence == "0") ? null : item[i].occurrence),
          "line_attrib_key": item[i].line_attrib_key,
          "Attribute_Name": item[i].attrib_name,
          "Attribute_Value": value,
          "trans_dtls_key": ((item[i].trans_details_key == "0") ? null : item[i].trans_details_key),
          "trans_status": "A"
        }];
        removeRow.push(tempJsonObj);
      }
      
      const scheduleDetails = {
        "addrows": [], 
        "editrows": [], 
        "removerows": removeRow
      };
      
      this.fir5471ScheduleOService.saveScheduleO(
        this.GENERAL_CONFIG.base_url,
        scheduleSettings,
        scheduleDetails,
        this.globalService,
        this.filterParams,
        this.rowData
      ).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (response: any) => {
          this.deletingItem = null; // Clear the deleting item
          if (response.errorMessage && response.errorMessage !== 'null') {
            this.gtwSnackbarService.openSnackBar(response.errorMessage, 'gtw-snackbar--red');
          } else {
            this.refreshDataAfterSave();
            this.gtwSnackbarService.openSnackBar('Data is successfully deleted', 'gtw-snackbar--green');
          }
        },
        (error: any) => {
          this.deletingItem = null; // Clear the deleting item
          console.error('Delete error:', error);
          this.gtwSnackbarService.openSnackBar('Error occurred while deleting. Please try again.', 'gtw-snackbar--red');
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
